var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _path, _path2, _rect, _path3, _path4, _rect2, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _view, _view2, _view3, _view4, _view5, _view6, _view7, _view8, _view9, _view10, _view11, _view12, _view13, _view14, _view15, _view16, _view17, _view18, _view19, _view20, _view21, _view22, _view23, _view24, _view25, _view26, _view27, _view28, _view29, _view30, _view31, _view32, _view33, _view34, _view35, _view36, _view37, _view38, _view39, _view40, _view41, _view42, _view43, _view44, _view45, _view46, _view47, _view48, _view49, _view50, _view51, _view52, _view53, _view54, _view55, _view56, _view57, _view58, _view59, _view60, _view61, _view62, _view63, _view64, _view65, _view66, _view67, _view68, _view69, _view70, _view71, _view72, _view73, _view74, _view75, _view76, _view77, _view78, _view79;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gr1",
    gradientUnits: "userSpaceOnUse",
    cx: 32,
    cy: 32,
    dx: 32,
    dy: 61,
    r: 28
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ad7de8",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#935cd6",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7940bf",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 62
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ad7de8",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#935cd6",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7940bf",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr2",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 25
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3d1fa",
      stopOpacity: 1
    },
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ad7de8",
      stopOpacity: 1
    },
    offset: "100%"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "_empty",
    viewBox: "0 0 64 64"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "_menu",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4,19.5h32.9c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3H16.4c-1.7,0-3,1.3-3,3C13.3,18.2,14.7,19.5,16.4,19.5z M49.2,29.9H16.3             c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3h32.9c1.7,0,3-1.3,3-3C52.2,31.2,50.9,29.9,49.2,29.9z M49.2,46.2H16.3c-1.7,0-3,1.3-3,3             s1.3,3,3,3h32.9c1.7,0,3-1.3,3-3C52.2,47.6,50.9,46.2,49.2,46.2z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "_refr2",
    viewBox: "-16 -16 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M49.7,32.8c0,10-8.101,18.2-18.2,18.2c-10.1,0-18.2-8.1-18.2-18.2c0-10,8.1-18.2,18.2-18.2c3.1,0,7,0.8,9.7,2.2L33.1,25.5 h28L54.1,0L47.2,8.4c-4.7-3-10.101-4.6-15.7-4.6c-7.8,0-15,3-20.6,8.5C5.5,17.8,2.5,25,2.5,32.8C2.5,49.4,16.2,62,31.5,62 c7.7,0,15-3.1,20.6-8.6c5.5-5.5,8.5-12.801,8.5-20.601V31H49.7V32.8L49.7,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,33.6C56.834,49.167,44.4,59.4,31.5,59.4C18,59.4,5.1,47.4,5.1,32.8c0-6.8,2.6-14.2,7.5-19 c4.8-4.8,12.2-7.5,19-7.5c5.4,0,11.6,1.7,15.9,4.9h0.4L52.6,5.6l4.9,17.3H38.8l5.8-6.8c-2-1.4-5.5-4.1-13.1-4.1 c-12,0-20.8,8.8-20.8,20.8s8.8,20.8,20.8,20.8c11.6,0,19.8-9,20.7-20H57.9z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "_refr",
    viewBox: "-16 -16 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,0.2C14,2.1,3.5,12,0.4,25.5C0.1,27.2,0,28.1,0,32c0,3.9,0.1,4.8,0.4,6.4C2.2,46.2,6.6,53,12.6,57.5 c8.6,6.4,19.3,8.2,29.3,4.9c2.6-0.9,6.3-2.7,8.4-4.2c2.2-1.6,6.3-5.6,7.5-7.5c1.5-2.2,1.4-2.2-3.2-5.4c-1.3-0.9-2.9-2-3.7-2.5 c-0.9-0.6-1.6-1-2-1c-0.6,0-0.6,0-2.6,2.4c-2.7,3.3-6.7,5.6-11.1,6.4c-1.8,0.3-5.2,0.3-7-0.1c-7.2-1.5-13-7.2-14.7-14.5 c-0.5-2.2-0.5-6,0-8.2c1.7-7.2,7.5-13,14.7-14.5c2-0.4,5.7-0.4,7.6,0c1.9,0.4,4.1,1.3,5.8,2.3c1.5,0.9,2,1.4,1.7,1.6 c-0.1,0.1-1.6,1.2-3.3,2.4c-3,2.2-3.1,2.3-3.1,2.9c0,0.4,0.1,0.8,0.3,1c0.2,0.2,1.4,0.6,2.6,1.1c1.2,0.4,5.4,1.8,9.2,3.1 c3.9,1.3,8.2,2.8,9.6,3.3c1.4,0.5,2.7,0.8,3,0.8c1-0.3,0.9,0.2,0.9-13.4V5.8l-0.4-0.4c-0.3-0.2-0.7-0.4-0.9-0.4 c-0.2,0-1.8,1-3.5,2.2l-3.1,2.2l-1.7-1.5C48.2,4,42.9,1.4,37.5,0.4C34.9,0,30-0.1,27.5,0.2z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "_repo2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3,37.6c0.9,0.9,1.9,1.9,2.8,2.8c4-4,8.1-8.1,12.2-12.2c1.5,1.5,3,3,4.4,4.4c4.4-4.4,8.9-8.9,13.4-13.4             c0.8,0.9,1.7,1.7,2.5,2.6c0.9-3.6,1.7-7.2,2.6-10.8c-3.6,0.9-7.1,1.8-10.8,2.6c0.9,0.9,1.8,1.8,2.7,2.7c-3.5,3.5-6.9,7-10.4,10.5             c-1.4-1.4-2.9-2.9-4.3-4.3C23.3,27.6,18.3,32.7,13.3,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,52.8c1.8,0,3.6,0,5.4,0c0-8.3,0-16.5,0-24.8c-1.8,0-3.6,0-5.4,0C44.2,36.3,44.2,44.6,44.2,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,33c0,6.7,0,13.3,0,19.8c1.8,0,3.6,0,5.4,0c0-6.6,0-13.3,0-19.8C38.7,33,36.9,33,35,33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,52.8c1.8,0,3.6,0,5.4,0c0-5,0-9.9,0-14.9c-0.1,0-0.2,0-0.3,0c-1.6,0-3.2,0-4.8,0c-0.2,0-0.3,0.1-0.3,0.3             c0,4.8,0,9.5,0,14.3C25.6,52.6,25.6,52.7,25.6,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6,52.8c1.8,0,3.6,0,5.4,0c0-3.3,0-6.6,0-9.9c-0.1,0-0.2,0-0.3,0c-1.6,0-3.2,0-4.8,0c-0.2,0-0.3,0.1-0.3,0.3             c0,3.2,0,6.3,0,9.4C16.6,52.7,16.6,52.8,16.6,52.8z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "_repo",
    viewBox: "-16 -16 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,40.4c1.4,1.4,2.8,2.8,4.2,4.2c6-6,12.1-12.1,18.2-18.2             c2.2,2.2,4.4,4.4,6.6,6.6c6.6-6.6,13.2-13.2,19.9-19.9c1.2,1.3,2.5,2.5,3.7,3.8c1.3-5.4,2.6-10.7,3.9-16c-5.4,1.3-10.6,2.6-16,3.9             c1.4,1.4,2.7,2.7,4,4C43.3,14,38.2,19.2,33,24.4c-2.1-2.1-4.3-4.3-6.4-6.4C19,25.5,11.5,33,4,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,63c2.7,0,5.3,0,8,0c0-12.3,0-24.5,0-36.8c-2.7,0-5.3,0-8,0C50,38.4,50,50.7,50,63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,33.5c0,9.9,0,19.7,0,29.5c2.7,0,5.3,0,8,0c0-9.8,0-19.7,0-29.5C41.8,33.5,39.1,33.5,36.4,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,63c2.7,0,5.4,0,8,0c0-7.4,0-14.7,0-22.1c-0.1,0-0.3,0-0.4,0c-2.4,0-4.8,0-7.2,0c-0.3,0-0.4,0.1-0.4,0.4             c0,7.1,0,14.2,0,21.2C22.4,62.7,22.4,62.8,22.4,63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,63c2.7,0,5.4,0,8,0c0-4.9,0-9.8,0-14.7c-0.1,0-0.3,0-0.4,0c-2.4,0-4.8,0-7.2,0c-0.3,0-0.4,0.1-0.4,0.4c0,4.7,0,9.4,0,14C9,62.8,9,62.9,9,63z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "_log2",
    viewBox: "-16 -16 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44.5,34.1l9.6-4.9c2.5-1.3,3.5-4.4,2.3-6.9c-0.6-1.2-1.6-2.2-2.9-2.6c-1.3-0.4-2.7-0.3-3.9,0.3l-5.5,2.8l-1.9-3.2 c5.3-1.3,8.6-6.6,7.4-12C48.3,2.3,42.9-1,37.5,0.3c-5.3,1.3-8.6,6.7-7.4,12c0.1,0.4,0.2,0.9,0.4,1.3l-11.9,5 c-1.5,0.6-2.7,1.9-3.1,3.5L13.2,32c-0.7,2.7,1,5.5,3.7,6.2c1.3,0.3,2.7,0.1,3.8-0.6c1.2-0.7,2-1.8,2.4-3.2l1.8-7.2l3.4-1.4 l-1.9,10.4L19,44.5l-6-5.3c-2.1-1.9-5.3-1.7-7.1,0.4c0,0,0,0.1-0.1,0.1C4,41.7,4.2,45,6.3,46.8l9.6,8.6c2.1,1.7,5.1,1.6,7-0.2 l9.3-9.4l7.4,4.5l5.4,10.9c0.9,1.7,2.6,2.8,4.6,2.8c0.8,0,1.6-0.2,2.3-0.5c2.5-1.3,3.5-4.3,2.3-6.9L48,44.3 c-0.4-0.9-1.1-1.6-1.9-2.1l-8.9-5.4l1-4.4C39.5,34.5,42.2,35.2,44.5,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3,26.7c-0.6,0.1-1.1,0.6-1.2,1.1L34,37.2c-0.1,0.6,0.1,1.2,0.7,1.6l9.8,6c0.4,0.2,0.6,0.5,0.8,0.9 l6.1,12.2c0.6,1.1,0.1,2.4-1,3l0,0c-1.1,0.5-2.3,0.1-2.9-1L42,48.6c-0.1-0.2-0.3-0.4-0.6-0.6l-8.7-5.3c-0.6-0.3-1.3-0.3-1.8,0.2 L20.8,53.1c-0.8,0.8-2.1,0.8-2.9,0.1l-9.6-8.6c-0.9-0.8-1-2.2-0.2-3.1c0.8-0.9,2.1-1,3-0.2c0,0,0,0,0,0l7.1,6.3 c0.6,0.5,1.5,0.5,2.1-0.1l8.6-9.6c0.1-0.2,0.3-0.4,0.3-0.7l2.4-13.4c0.1-0.8-0.4-1.6-1.2-1.7c-0.3-0.1-0.6,0-0.8,0.1L23,24.8 c-0.4,0.2-0.7,0.6-0.8,1l-2,7.9c-0.1,0.6-0.5,1.1-1,1.4c-0.5,0.3-1.1,0.4-1.6,0.2c-1.1-0.3-1.9-1.5-1.6-2.7l2.4-9.8 c0.2-0.7,0.7-1.3,1.4-1.5l11.6-4.9l1.8,0.8c0.7,0.3,1.6-0.1,1.9-0.8c0.3-0.5,0.1-1.1-0.3-1.6c-1.2-1.3-2-3.1-2-4.9 c0-3.9,3.2-7,7.1-6.9s6.9,3.2,6.9,7.1c0,3.8-3.1,6.9-7,6.9c-0.8,0-1.5,0.7-1.5,1.5c0,0.3,0.1,0.5,0.2,0.7l3.6,6.1 c0.3,0.5,0.8,0.8,1.4,0.7L44,26c0.2,0,0.4-0.1,0.5-0.1l6.4-3.3c0.5-0.3,1.1-0.3,1.6-0.1c0.6,0.2,1,0.6,1.3,1.1 c0.5,1.1,0.1,2.4-1,2.9l-9.7,4.9c-1.1,0.5-2.3,0.1-2.9-1l-1.5-3C38.5,27,38,26.7,37.3,26.7z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "_log",
    viewBox: "-16 -16 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4,64C5.1,64,0,58.9,0,52.6V11.4C0,5.1,5.1,0,11.4,0h23.5c6.3,0,11.4,5.1,11.4,11.4v4.7c0,2.4-1.9,4.3-4.3,4.3 c-2.4,0-4.3-1.9-4.3-4.3v-4.7c0-1.5-1.2-2.7-2.7-2.7H11.4c-1.5,0-2.7,1.2-2.7,2.7v41.3c0,1.5,1.2,2.7,2.7,2.7h23.5 c1.5,0,2.7-1.2,2.7-2.7v-4.7c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v4.7c0,6.3-5.1,11.4-11.4,11.4H11.4z M53.4,44.2 c-1.2,0-2.3-0.5-3.1-1.3c-0.8-0.8-1.3-2-1.3-3.2c0-1.1,0.5-2.2,1.3-2.9l0.3-0.3H27.3c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3 h23.3l-0.3-0.3c-0.8-0.8-1.3-2-1.3-3.2c0-1.1,0.5-2.2,1.3-2.9c0.8-0.8,1.9-1.3,3.1-1.3c1.2,0,2.3,0.5,3.1,1.3l5.2,5.2 c3.1,3.1,3.1,8,0.1,11.1l-5.3,5.3C55.7,43.7,54.6,44.2,53.4,44.2z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "cancel",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,56c-4-2-7-5-11-8c-5-5-9-9-13-15 c4-6,8-10,13-15c3-3,7-6,11-8c1-1,10-5,7-6 c-12-4-27,7-37,16C21,10,12-2,5,2C-4,8,7,23,15,33 C7,43-4,59,5,64c7,4,16-8,22-18c10,9,25,20,37,16 C67,61,58,57,57,56z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "ok",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,30c-0,0-0,0-1,1c2-3,5-6,8-9c3-3,6-6,9-8c2-1,3-2,5-3c1-1,2-1,2-1C63,8,64,8,64,7c0-2-6-1-7-1c0,0,1-0,1-0c-1,0-1,0-1,0c1,0,1-0,2-0c-2,0-4,1-5,1c-2,1-4,2-6,3c-4,3-8,6-12,9c-4,3-7,7-11,11 c-2,2-3,4-5,6C20,36,19,38,18,38c-1-0-1-2-1-3c-0-1-1-2-1-3c-1-2-2-4-4-4c-4-2-8-1-11,2c-1,2-2,4-1,5c0,2,2,4,3,6c1,2,2,5,3,7c1,2,2,4,3,6c2,2,3,4,6,4c1,0,3-0,4-1c1-1,2-2,3-3c4-5,7-11,11-17L39,30z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "_pencil",
    viewBox: "0 0 64 64"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7,12.2C47.2,7.8,43,10.6,40,13.7L14.7,39l1.4-1.4l0,0l0,0l0,0l0,0L13.4,50l0,0l0,0l0,0l0,0l0,0l0,0l0.7,0.7l0,0             l12.4-2.8l0,0l0,0l0,0l0,0L25,49.3L50.3,24C53.6,20.7,56.2,16.7,51.7,12.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777777",
    d: "M51,12.9c4.5,4.5,0.4,8.6,0.4,8.6l-8.9-8.9C42.4,12.6,46.6,8.5,51,12.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 20.2,
    transform: "matrix(0.7078 0.7064 -0.7064 0.7078 27.5599 -23.8231)",
    fill: "#FFFFFF",
    width: 12.6,
    height: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1A6",
    d: "M19.9,44.2l5.4-1.1l0.7,4l-9.8,2.2l1.3-1.3c0,0,0.2-0.8-0.1-1.1c-0.3-0.3-1.1-0.1-1.1-0.1l-1.3,1.3l2.1-9.7             l3.7,0.2L19.9,44.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 28,
    y1: 28,
    x2: 38,
    y2: 38
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7C00F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98620E"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M26.2,42.6l14.1-14.2c0,0,0.5-0.8,0.3-1c-0.2-0.2-1,0.3-1,0.3L25.4,42.1l-4.2,0.8l0.4-4.5l14.6-14.7             c0,0,0.5-0.9,0.3-1c-0.2-0.2-1,0.4-1,0.4L21.1,37.5l-3.4-0.1l18.9-18.9l8.9,8.9L26.8,46.1L26.2,42.6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 17.3,
    transform: "matrix(0.7078 0.7064 -0.7064 0.7078 26.474 -26.4306)",
    fill: "#FFFFFF",
    width: 12.6,
    height: 2.9
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "_pencil2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,62.5l4.1-19.3L40.7,6.9C44.5,2.9,48,1,51.4,1c2.7,0,5.4,1.3,7.7,3.7c2.6,2.5,3.9,5.1,3.9,7.8c0,3.4-1.9,6.9-5.9,10.8 L20.8,59.7L1.5,64.1L0,62.5z M5.8,57c0.5,0,0.9,0.1,1.1,0.3L7,57.4c0.5,0.5,0.4,1.6,0.4,2c0,0.1,0,0.2,0,0.3v0.6l11.7-2.7l-0.9-5.1 l-8.4,1.7l1.3-8.7l-4.6-0.1L4.1,57.1h0.6c0,0,0.1,0,0.3,0C5.2,57.1,5.5,57,5.8,57z M41.8,27.4c0.2,0,0.4,0.1,0.5,0.2 c0.6,0.6,0.2,1.5-0.3,2.2l0,0L20.6,51.4l0.7,4L48.6,28L35.9,15.2L8.3,42.7l3.8,0.2l21.7-21.6l0.2-0.1c0.5-0.3,1.1-0.7,1.7-0.7 c0.1,0,0.3,0.1,0.4,0.2l0.1,0.1l0.1,0.3c0.1,0.2,0.2,0.5-0.6,1.9L13.6,44.9l-0.5,6l5.6-1.1L40.4,28C40.7,27.7,41.4,27.4,41.8,27.4z  M37.6,13.6l12.8,12.8l2-2L39.6,11.6L37.6,13.6z M41.3,9.8l12.9,12.8l2.4-2.4L43.7,7.3L41.3,9.8z M51.2,3.4c-2.2,0-4.2,1.1-5.1,1.7 l-0.5,0.3l12.8,12.8l0.4-0.5c1.3-1.8,3.6-6.5-1.3-11.5C55.5,4.4,53.4,3.4,51.2,3.4z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "_table",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4,30.2c0,0.8,0,1.5,0,2.2c0,7.2,0,14.4,0,21.6c0,1.4-0.3,1.6-1.6,1.6c-1,0-2.1,0-3.2,0c-1.2,0-1.6-0.3-1.6-1.6             c0-7.7,0-15.3,0-23c0-0.3,0-0.5,0-0.9c-5.3-0.1-10.6-0.7-15.8-1.7c0,0.3,0,0.5,0,0.8c0,10.4,0,20.7,0,31.1c0,1.3-0.3,1.6-1.6,1.6             c-1.1,0-2.2,0-3.4,0c-1,0-1.3-0.3-1.3-1.4c0-11,0-33.9,0-33.9s-0.2-0.1-0.8-0.5c-1.3-0.6-2.6-1.3-3.8-2.2C1,23.1,0.9,21.8,1,20.1             c0.1-1.1,0-2.2,0-3.3c0-1.3-0.1-2.3,0.8-3.2c1.4-1.4,3.1-2.2,4.9-2.9c3.4-1.4,7-2.1,10.7-2.7c5.7-0.9,11.5-1.2,17.3-1             c7.1,0.2,14.3,0.9,21.1,3c2,0.6,3.9,1.4,5.7,2.6c1.6,1.2,1.5,2.6,1.4,4.7v3c0,0,0.2,2.7-0.3,3.2c-1.2,1.3-2.8,2-4.4,2.7             c-0.5,0.2-0.7,0.3-0.7,0.3s0,22.7,0,33.7c0,1.3-0.3,1.6-1.6,1.6c-1.1,0-2.2,0-3.3,0c-1.1,0-1.4-0.4-1.4-1.4c0-10.4,0-20.8,0-31.2             c0-0.3,0-0.6,0-0.9C46,29.5,40.8,30.1,35.4,30.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FF9240",
    cx: 32.1,
    cy: 16,
    rx: 30,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6700",
    d: "M62,21.1c0,4.2-13.2,7.6-29.5,7.6S2,25.2,2,21.1v-2.5c0,0,4.1,6.6,30.5,6.9C59.8,25.8,62,18.6,62,18.6             S62,20.8,62,21.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AD4600",
    points: "11.9,60.4 8.4,60.4 8.4,27.4 11.9,28.3 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AD4600",
    points: "52.8,60.1 56.3,60.1 56.3,27.1 52.8,28 "
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "_qr2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6,6 22,6 22,2 2,2 2,22 6,22  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,22V10H10v12H22z M14,14h4v4h-4V14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41,2 41,6 58,6 58,22 62,22 62,2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,22V10H42v12H54z M46,14h4v4h-4V14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6,42 2,42 2,62 22,62 22,58 6,58  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,42h-4v12h12V42H14z M18,50h-4v-4h4V50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58,58 41,58 41,62 62,62 62,42 58,42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34,38 50,38 50,46 54,46 54,34 34,34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54,54 54,50 30,50 30,34 10,34 10,38 26,38 26,54  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10,30 38,30 38,10 34,10 34,26 10,26  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    width: 12,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 42,
    width: 4,
    height: 4
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "_qr",
    viewBox: "-16 -16 96 96"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 10.5,
    width: 4.2,
    height: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2H2v22h22V2z M18.8,18.9H7.1V7.1h11.7V18.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.9,
    y: 10.5,
    width: 4.2,
    height: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,2v22h22V2H40z M56.9,18.9H45.1V7.1h11.8V18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,62h22V40H2V62z M7.1,45.1h11.7v11.8H7.1V45.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 48.5,
    width: 4.2,
    height: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3,31.6h-4.2v4.2v0.9V41H40.4v-5.2h-4.2V41H32v-4.3v-0.9v-3.3h4.2v-5.1h-3.7V24h4.2V10.4h-4.2V7.1h3.7V2h-8.9v13.6h4.2 v4.3h-4.2v7.9H32v3.8H19.3v-4.2h-8.4v4.2H6.7v-4.2H2.5v5.1h4.2v4.2h4.2v-4.2h4.2v4.2h12.7v4.2H32v3.3h-4.2v4.3v0.8v3.4v0.9v4.2H32 V62h16.9v-4.2v-0.9v-3.3h8.4v4.3h-4.2V62h4.2v-4.2h4.2v-4.1h-4.2v-5.4h4.2v-4.1h-4.2v-3.3V40v-3.3h4.2v-4.2v-0.9v-4.2h-4.2V31.6z  M36.2,40.9h4.2v4.3h-4.2V40.9z M32,45.1h4.2v3.4H32V45.1z M48.9,53.7h-4.2v-4.2h-4.2v4.1h4.2v3.3H32v-3.3h4.2v-4.3h4.2v-4.2h8.5 v3.4v0.8V53.7z M57.3,48.5h-4.2v-4.4h4.2V48.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.9,36.7 48.9,32.5 48.9,31.6 48.9,27.4 40.5,27.4 40.5,32.5 44.7,32.5 44.7,36.7  "
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gr1)",
    stroke: "#7940bf",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48 48 61 32 61C16 61 3 48 3 32C3 16 16 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gr2)",
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn_2",
    viewBox: "0 0 128 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gr1_)",
    stroke: "#7940bf",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M125 32c0 16-13 29-28 29C96 61 32 61 32 61C16 61 3 48 3 32S16 3 32 3c0 0 64 0 64 0C112 3 125 16 125 32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gr2)",
    d: "M117 19c0 8-9 14-20 14C96 33 32 33 32 33c-12 0-21-6-21-14S20 5 32 5c0 0 64 0 64 0C107 5 117 11 117 19z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn1",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,24V11H24v13H11v16h13v13h16V40h13V24H40z M51,38H38v13H26V38H13V26h13V13h12v13h13V38z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,24.1v15.8h44V24.1H10z M52,37.9H12V26.1h40V37.9z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "_btn3",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8667,
    y1: 31.5,
    x2: 48.1328,
    y2: 31.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F9F9F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000",
    d: "M24.5,11.5c-2,0-3.7,1.6-3.7,3.7v32.7c0,2,1.6,3.7,3.7,3.7h19.9c2,0,3.7-1.6,3.7-3.7V15.1             c0-2-1.6-3.7-3.7-3.7H24.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2,43.2h-3.4c-1,0-1.7,0.8-1.7,1.7v2.9c0,1,0.8,1.7,1.7,1.7h3.4c1,0,1.7-0.8,1.7-1.7v-2.9C37.9,44,37.2,43.2,36.2,43.2z              M36.9,47.9c0,0.4-0.3,0.7-0.7,0.7h-3.4c-0.4,0-0.7-0.3-0.7-0.7v-2.9c0-0.4,0.3-0.7,0.7-0.7h3.4c0.4,0,0.7,0.3,0.7,0.7V47.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,43.2h-3.4c-1,0-1.7,0.8-1.7,1.7v2.9c0,1,0.8,1.7,1.7,1.7h3.4c1,0,1.7-0.8,1.7-1.7v-2.9C29.7,44,28.9,43.2,27.9,43.2z              M28.7,47.9c0,0.4-0.3,0.7-0.7,0.7h-3.4c-0.4,0-0.7-0.3-0.7-0.7v-2.9c0-0.4,0.3-0.7,0.7-0.7h3.4c0.4,0,0.7,0.3,0.7,0.7V47.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1,49.6c-1,0-1.7-0.8-1.7-1.7V36.1c0-1,0.8-1.7,1.7-1.7h3.4c1,0,1.7,0.8,1.7,1.7v11.7c0,1-0.8,1.7-1.7,1.7H41.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFABAB",
    d: "M41.1,35.4c-0.4,0-0.7,0.3-0.7,0.7v11.7c0,0.4,0.3,0.7,0.7,0.7h3.4c0.4,0,0.7-0.3,0.7-0.7V36.1             c0-0.4-0.3-0.7-0.7-0.7H41.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2,34.4h-3.4c-1,0-1.7,0.8-1.7,1.7v2.9c0,1,0.8,1.7,1.7,1.7h3.4c1,0,1.7-0.8,1.7-1.7v-2.9C37.9,35.2,37.2,34.4,36.2,34.4             z M36.9,39.1c0,0.4-0.3,0.7-0.7,0.7h-3.4c-0.4,0-0.7-0.3-0.7-0.7v-2.9c0-0.4,0.3-0.7,0.7-0.7h3.4c0.4,0,0.7,0.3,0.7,0.7V39.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,34.4h-3.4c-1,0-1.7,0.8-1.7,1.7v2.9c0,1,0.8,1.7,1.7,1.7h3.4c1,0,1.7-0.8,1.7-1.7v-2.9C29.7,35.2,28.9,34.4,27.9,34.4             z M28.7,39.1c0,0.4-0.3,0.7-0.7,0.7h-3.4c-0.4,0-0.7-0.3-0.7-0.7v-2.9c0-0.4,0.3-0.7,0.7-0.7h3.4c0.4,0,0.7,0.3,0.7,0.7V39.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2,25.6h-3.4c-1,0-1.7,0.8-1.7,1.7v2.9c0,1,0.8,1.7,1.7,1.7h3.4c1,0,1.7-0.8,1.7-1.7v-2.9C37.9,26.4,37.2,25.6,36.2,25.6             z M36.9,30.3c0,0.4-0.3,0.7-0.7,0.7h-3.4c-0.4,0-0.7-0.3-0.7-0.7v-2.9c0-0.4,0.3-0.7,0.7-0.7h3.4c0.4,0,0.7,0.3,0.7,0.7V30.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,25.6h-3.4c-1,0-1.7,0.8-1.7,1.7v2.9c0,1,0.8,1.7,1.7,1.7h3.4c1,0,1.7-0.8,1.7-1.7v-2.9C29.7,26.4,28.9,25.6,27.9,25.6             z M28.7,30.3c0,0.4-0.3,0.7-0.7,0.7h-3.4c-0.4,0-0.7-0.3-0.7-0.7v-2.9c0-0.4,0.3-0.7,0.7-0.7h3.4c0.4,0,0.7,0.3,0.7,0.7V30.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5,25.6h-3.4c-1,0-1.7,0.8-1.7,1.7v2.9c0,1,0.8,1.7,1.7,1.7h3.4c1,0,1.7-0.8,1.7-1.7v-2.9C46.2,26.4,45.4,25.6,44.5,25.6             z M45.2,30.3c0,0.4-0.3,0.7-0.7,0.7h-3.4c-0.4,0-0.7-0.3-0.7-0.7v-2.9c0-0.4,0.3-0.7,0.7-0.7h3.4c0.4,0,0.7,0.3,0.7,0.7V30.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,22.7c-1,0-1.7-0.8-1.7-1.7v-5.9c0-1,0.8-1.7,1.7-1.7h19.9c1,0,1.7,0.8,1.7,1.7V21c0,1-0.8,1.7-1.7,1.7H24.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDDDDD",
    d: "M44.5,14.4c0.4,0,0.7,0.3,0.7,0.7V21c0,0.4-0.3,0.7-0.7,0.7H24.5c-0.4,0-0.7-0.3-0.7-0.7v-5.9             c0-0.4,0.3-0.7,0.7-0.7H44.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3,15.6c-1,0-1.7,0.8-1.7,1.7v1.5c0,1,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7v-1.5C44,16.4,43.2,15.6,42.3,15.6z M43,18.8             c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-1.5c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7V18.8z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn4",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4,39.4l-5-25.1c-0.2-1.4-0.9-2.5-2-3.5c-1.1-1.1-2.8-1.8-4.5-1.8c-0.5,0-0.8,0-1.3,0.1l-40.8,8 c-2,0.3-3.7,1.7-4.7,3.7c-0.6,1.3-0.7,2.5-0.5,4l5,25c0.4,1.7,1.4,3.3,2.8,4.3c1,0.7,3.2,1.1,4.7,1.1c0.5,0,0.8,0,1.3-0.1l40-8 c1.8-0.4,3.2-1.3,4.2-2.8C61.5,42.7,61.7,41.1,61.4,39.4z M8.1,18.5l41-8c0.3-0.1,0.7-0.1,1-0.1c1.1,0,2.2,0.4,3.1,1.1l-16,17.3 l-2.7,2.9c-0.8,0.9-2,1.4-3.2,1.4c-0.6,0-1.2-0.1-1.8-0.4l-3.7-1.8L4.5,21C5.2,19.7,6.6,18.8,8.1,18.5z M8.9,49.8l-5-25.1 c-0.2-1-0.1-1.9,0.2-2.8l20.8,9.6L10.7,52.8C9.7,52,9.1,51,8.9,49.8z M56.1,45.8l-41.1,8c-0.3,0.1-0.7,0.1-1,0.1 c-0.9,0-1.8-0.2-2.5-0.6L25.8,32l3.2,1.5c0.7,0.3,1.5,0.5,2.3,0.5c1.5,0,2.9-0.7,3.9-1.8l2.4-2.6L59.1,44 C58.3,45,57.2,45.6,56.1,45.8z M59.6,43.2L38.4,29L54,12.1c0.7,0.8,1.1,1.6,1.3,2.5l4.8,25C60.3,41,60.1,42.2,59.6,43.2z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn5",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_pencil2",
    width: 52,
    height: 52,
    x: 6,
    y: 6
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn6",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,11.1h-5.3V4.2l-1.6-1.9L4.1,20l20.8,16.7l1.8-1.9v-6.1h5c4.2,0,8.2,1.5,11.3,4c3.1,2.6,4.8,6.3,4.8,10.4 c0,6.9-4.6,13.5-10.9,15.8l0.5,2.7C51,59.8,59.1,51,59.1,38.3C59.1,22.8,47.5,11.1,32,11.1z M37.3,60.3c6.7-2.4,11.9-9.3,11.9-17 c0-4.5-1.9-8.6-5.3-11.5c-3.2-2.7-7.5-4.3-12.1-4.3h-6.3v6.9L24.9,35L6.4,20L24.9,4.1l0.4,0.5v7.8H32c14.7,0,25.7,11.2,25.7,25.9 C57.8,50.5,50.1,58.6,37.3,60.3z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn7",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.4,
    y: 45.2,
    width: 21.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4,
    y: 51.7,
    width: 15.1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9,26.3c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.4,3.3c1.8,0,3.3-1.5,3.3-3.3C55.2,27.8,53.7,26.3,51.9,26.3z  M51.9,31.7c-1.2,0-2.2-0.9-2.2-2.1s1-2.1,2.1-2.1c1.2,0,2.1,0.9,2.1,2.1C54,30.8,53.1,31.7,51.9,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,27.6c-0.1-3.1-2.4-5.6-5.2-6.1c-1-0.2-2-0.2-3-0.2h-2.3V10.8c0,0,0.2-5-3.8-5H18.7c-2.4,0-4,1.8-4.1,4.8 c-0.1,2.7,0,10.8,0,10.8h-4c-1-0.1-1.9,0.1-2.8,0.5c-2.1,1.1-3.2,2.8-3.4,5.1l0,15.7c1,2.5,2.7,4.1,5.4,4.4l4.6,0.1l0,7.2 c0,0,0.3,3.8,4.3,3.8H46c3.5,0,3.8-3.8,3.8-3.8v-7.2l5.2-0.1c2.2-0.3,3.7-1.5,4.7-3.5c0.5-0.9,0.6-1.8,0.6-2.8 C60.3,36.3,60.4,32,60.3,27.6z M16.4,10.6c0-1.1,0.4-3,2.3-3H46c0.7,0,1,0.3,1.2,0.4c0.7,0.7,0.8,2.3,0.8,2.6l0,10.7l-31.6,0 C16.4,21.1,16.3,13.2,16.4,10.6z M48,54.3c-0.1,0.5-0.4,2.1-2,2.1H18.7c-2,0-2.4-1.4-2.4-2.1l0-13.3H48V54.3z M58.5,36.3 c0,1.5,0,2.9,0,4.4c0,0.8-0.1,1.4-0.4,2c-0.8,1.5-1.8,2.3-3.2,2.5l-4.9,0.1V41c0,0-0.4-1.8-2-1.8H16.6c-2,0-2.3,1.8-2.3,1.8l0,4.4 l-4.4-0.1c-1.8-0.3-3-1.2-3.8-3l0-15.3c0.2-1.7,1-2.8,2.5-3.6c0.5-0.2,1-0.4,1.5-0.4l42,0c0.9,0,1.8,0,2.7,0.2 c2.1,0.3,3.7,2.2,3.8,4.3C58.6,30.5,58.6,33.5,58.5,36.3z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn8",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7,18.7c1.5-0.9,3.1-1.7,4.6-2.7c1.3-0.9,2.7-1.9,3.8-3.2c0.9-1.3,1.3-2.7,1-4.3c-0.3-1.3-1-2.1-2.5-1.9 c-0.8,0-1.4,0.3-2.1,0.5c-3.4,1.6-6.4,3.6-8.9,6.2c-0.4,0.4-0.8,0.8-1.1,1.3c0,0,0,0,0,0L29.3,14c-0.8,0-1.4,0.3-2.1,0.9L2,40.3 c-0.3,0.3-0.8,0.8-0.8,1.6s0.4,1.2,0.8,1.6c6.4,6.5,12.8,12.8,18.2,18.3c0.1,0.3,0.8,0.8,1.6,0.8c0.8,0,1.3-0.5,1.4-0.8l25.3-25.4 c0.4-0.5,1-1.3,0.9-2.5L48.7,18.7z M45.5,16.1c0.6,0,1.4-0.1,1.8,0.1c0.5,0.4,0.2,1.2,0.1,1.9c-2.4,1.2-4.7,2.7-6.6,4.5 c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0c-0.3-0.1-0.5-0.5-0.8-0.5c-0.4-0.3-0.6-0.4-1-0.4c-1.9-0.4-3.8,1-3.9,3c0,1.3,0.7,2.6,1.9,3.2 c1.2,0.5,2.7,0.4,3.6-0.5c1-0.9,1.3-2.3,0.8-3.8c0.8-1,1.7-1.8,2.7-2.5c1.1-0.8,2.3-1.4,3.5-2l0.5,14.9c0,0.5-0.1,0.9-0.5,1.3 L22.3,60.8c-0.5,0.5-0.8,0.5-1.3,0C14.9,54.7,8.8,48.6,2.7,42.5c-0.5-0.5-0.4-0.8,0-1.2L28,16c0.4-0.4,0.8-0.5,1.3-0.5L45.5,16.1z  M39.8,26.3c-0.4,0.4-0.9,0.5-1.4,0.5c-0.4,0-0.7,0-0.9-0.1c-0.8-0.4-1.2-1.2-1.2-1.9c0-1,0.9-1.8,1.9-1.8c0.1,0,0.2,0,0.3,0.1 c-0.1,0.2-0.3,0.3-0.3,0.7c-0.1,0.5-0.1,0.9,0.4,1.2c0.4,0.3,0.9,0.3,1.3-0.1c0.1-0.1,0.3-0.2,0.4-0.3 C40.5,25.2,40.4,25.8,39.8,26.3z M39.5,23.3C39.5,23.3,39.5,23.4,39.5,23.3l0.2,0.2c0,0,0.1,0,0.1,0.1c-0.2,0.1-0.4,0.3-0.6,0.3 C39.3,23.6,39.4,23.5,39.5,23.3z M56.8,11.3c-0.4,0.5-0.6,1-1.2,1.4c-2,1.9-4.3,3.4-6.9,4.7c0,0,0,0,0-0.1c0.1-0.6,0.3-1.7-0.7-2.3 c-0.5-0.5-1.2-0.5-1.6-0.5c-0.1,0-0.4,0-0.5,0c-0.1,0-0.3,0-0.4,0h-0.1c-0.4,0-0.7,0-1,0c0,0,0,0,0,0c0.5-0.7,1.1-1.3,1.7-1.8 c2.2-1.8,4.5-3.2,7-4.5c0.7-0.4,1.4-0.7,2.2-0.8c1.2-0.3,1.8,0.3,1.9,1.4C57.5,9.7,57.3,10.5,56.8,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,37.7c1.2,1.2,1.8,2.3,1.8,3.5c0,1.2-0.5,2.2-1.6,3.3S19.8,46,18.7,46c-1.2,0-2.2-0.6-3.4-1.8 c-1.2-1.2-1.8-2.3-1.8-3.5c0-1.2,0.5-2.2,1.6-3.3c1.1-1.1,2.2-1.6,3.3-1.6C19.6,35.9,20.6,36.5,21.8,37.7z M19.8,39.8 c-0.8-0.7-1.4-1.2-1.8-1.3c-0.4-0.1-0.8,0-1.3,0.5c-0.4,0.4-0.5,0.8-0.4,1.3c0.1,0.4,0.5,1.1,1.3,1.8c0.7,0.7,1.4,1.3,1.8,1.3 c0.5,0.1,0.9-0.1,1.3-0.4c0.4-0.4,0.5-0.8,0.5-1.3C20.9,41.2,20.5,40.5,19.8,39.8z M24.2,28.9l5.1,16.3l-1.9,1.9l-5.2-16.3 L24.2,28.9z M36,31.8c1.2,1.2,1.8,2.3,1.8,3.5c0,1.2-0.5,2.2-1.6,3.3S34,40.1,33,40.1c-1.2,0-2.2-0.6-3.4-1.8 c-1.2-1.2-1.8-2.3-1.8-3.5c0-1.2,0.5-2.2,1.6-3.3s2.2-1.6,3.3-1.6C33.7,30,34.9,30.6,36,31.8z M33.9,33.9c-0.8-0.7-1.4-1.2-1.8-1.3 c-0.4-0.1-0.8,0.1-1.3,0.4c-0.4,0.4-0.5,0.8-0.4,1.3c0.1,0.4,0.5,1.1,1.3,1.8c0.7,0.7,1.4,1.2,1.8,1.3c0.4,0.1,0.8-0.1,1.3-0.4 c0.4-0.4,0.6-0.8,0.5-1.3C35.1,35.2,34.7,34.6,33.9,33.9z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn81",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7,18.7c1.5-0.9,3.1-1.7,4.6-2.7c1.3-0.9,2.7-1.9,3.8-3.2c0.9-1.3,1.3-2.7,1-4.3c-0.3-1.3-1-2.1-2.5-1.9 c-0.8,0-1.4,0.3-2.1,0.5c-3.4,1.6-6.4,3.6-8.9,6.2c-0.4,0.4-0.8,0.8-1.1,1.3c0,0,0,0,0,0L29.3,14c-0.8,0-1.4,0.3-2.1,0.9L2,40.3 c-0.3,0.3-0.8,0.8-0.8,1.6s0.4,1.2,0.8,1.6c6.4,6.5,12.8,12.8,18.2,18.3c0.1,0.3,0.8,0.8,1.6,0.8c0.8,0,1.3-0.5,1.4-0.8l25.3-25.4 c0.4-0.5,1-1.3,0.9-2.5L48.7,18.7z M45.5,16.1c0.6,0,1.4-0.1,1.8,0.1c0.5,0.4,0.2,1.2,0.1,1.9c-2.4,1.2-4.7,2.7-6.6,4.5 c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0c-0.3-0.1-0.5-0.5-0.8-0.5c-0.4-0.3-0.6-0.4-1-0.4c-1.9-0.4-3.8,1-3.9,3c0,1.3,0.7,2.6,1.9,3.2 c1.2,0.5,2.7,0.4,3.6-0.5c1-0.9,1.3-2.3,0.8-3.8c0.8-1,1.7-1.8,2.7-2.5c1.1-0.8,2.3-1.4,3.5-2l0.5,14.9c0,0.5-0.1,0.9-0.5,1.3 L22.3,60.8c-0.5,0.5-0.8,0.5-1.3,0C14.9,54.7,8.8,48.6,2.7,42.5c-0.5-0.5-0.4-0.8,0-1.2L28,16c0.4-0.4,0.8-0.5,1.3-0.5L45.5,16.1z  M39.8,26.3c-0.4,0.4-0.9,0.5-1.4,0.5c-0.4,0-0.7,0-0.9-0.1c-0.8-0.4-1.2-1.2-1.2-1.9c0-1,0.9-1.8,1.9-1.8c0.1,0,0.2,0,0.3,0.1 c-0.1,0.2-0.3,0.3-0.3,0.7c-0.1,0.5-0.1,0.9,0.4,1.2c0.4,0.3,0.9,0.3,1.3-0.1c0.1-0.1,0.3-0.2,0.4-0.3 C40.5,25.2,40.4,25.8,39.8,26.3z M39.5,23.3C39.5,23.3,39.5,23.4,39.5,23.3l0.2,0.2c0,0,0.1,0,0.1,0.1c-0.2,0.1-0.4,0.3-0.6,0.3 C39.3,23.6,39.4,23.5,39.5,23.3z M56.8,11.3c-0.4,0.5-0.6,1-1.2,1.4c-2,1.9-4.3,3.4-6.9,4.7c0,0,0,0,0-0.1c0.1-0.6,0.3-1.7-0.7-2.3 c-0.5-0.5-1.2-0.5-1.6-0.5c-0.1,0-0.4,0-0.5,0c-0.1,0-0.3,0-0.4,0h-0.1c-0.4,0-0.7,0-1,0c0,0,0,0,0,0c0.5-0.7,1.1-1.3,1.7-1.8 c2.2-1.8,4.5-3.2,7-4.5c0.7-0.4,1.4-0.7,2.2-0.8c1.2-0.3,1.8,0.3,1.9,1.4C57.5,9.7,57.3,10.5,56.8,11.3z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn9",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9,50.7c-1.7,0-3.1-1.2-3.4-2.9L8.1,24.1c-0.3-1.9,0.9-3.7,2.8-4.1l36.6-6.7c0.2,0,0.4-0.1,0.6-0.1             c1.7,0,3.1,1.2,3.4,2.9l4.4,23.7c0.3,1.9-0.9,3.7-2.8,4.1l-36.6,6.7C16.3,50.7,16.1,50.7,15.9,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M55,40c0.2,1.4-0.6,2.7-2,2.9l-36.6,6.7c-1.4,0.3-2.7-0.6-2.9-2L9,24c-0.3-1.4,0.6-2.7,2-2.9l36.6-6.7             c1.4-0.2,2.7,0.6,2.9,2L55,40L55,40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F1A",
    d: "M20.5,34.3l-1.8-4.5c-0.3-0.6-0.8-0.7-1.4-0.6L12.8,30l0,0.2C16.4,30.4,19.1,32,20.5,34.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#059BBF",
    points: "29.8,26.9 26.9,27.5 27.1,38.4 30,37.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059BBF",
    d: "M23.2,39.1l2.6-11.4l-3.1,0.6L21.2,36l-0.5-1c-0.8-1.2-2.7-2.8-4.8-3.7l4.2,8.4L23.2,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059BBF",
    d: "M39.4,32.5c-0.2-1.2-1.2-2-3-2.4c-1.1-0.3-1.8-0.5-1.9-1c-0.1-0.4,0.4-1,1.5-1.2c0.9-0.2,1.7-0.1,2.2,0             l0.3,0.1l0-2.4c-0.6-0.1-1.5-0.2-2.7,0C33,26.2,31.3,28,31.6,30c0.3,1.5,1.9,2.1,3.1,2.4c1.2,0.3,1.7,0.6,1.7,1             c0.1,0.7-0.7,1.2-1.5,1.4c-1.2,0.2-1.8,0.2-2.8-0.1l-0.4-0.1l0,2.4c0.7,0.2,2,0.2,3.3,0C38.1,36.5,39.8,34.8,39.4,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059BBF",
    d: "M43.2,33.8c0.3-0.1,3.3-0.6,3.7-0.7c0.2,0.4,0.6,1.5,0.6,1.5l2.7-0.5L45.9,24l-2.2,0.4             c-0.7,0.1-1.2,0.4-1.3,1.2l-2.5,10.5l3-0.6C42.9,35.5,43.1,34.1,43.2,33.8z M44.2,28.3c0,0,0.1-0.7,0.2-1.1l0.4,0.9             c0,0,1,2.4,1.2,2.9l-2.4,0.4C43.7,30.8,44.2,28.3,44.2,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059BBF",
    d: "M47.7,14.3L11,21c-1.4,0.3-2.3,1.6-2,2.9l0.5,2.5l41.5-7.6l-0.5-2.5C50.3,14.9,49,14.1,47.7,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F1A",
    d: "M53,43l-36.6,6.7c-1.4,0.3-2.7-0.6-2.9-2l-0.5-2.5l41.5-7.6L55,40C55.2,41.4,54.3,42.7,53,43z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#202121",
    enableBackground: "new    ",
    d: "M15.2,47.4l-4.4-23.7c-0.2-1.4,0.6-2.7,2-2.9L11,21             c-1.4,0.3-2.3,1.6-2,2.9l4.4,23.7c0.3,1.4,1.6,2.3,2.9,2l1.7-0.3C16.7,49.6,15.4,48.7,15.2,47.4z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn10",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M49,37.5c0,0-0.1,0.1-0.1,0.1C48.9,37.6,49,37.6,49,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9,33.6c-0.4-2.6-5.9-3.9-11.3-4.1v-5.1v-5.4c0-0.1,0-0.1,0-0.2c-0.4-2.8-6.3-4.1-11.9-4.1l-0.3,0             c-5.8,0-12.1,1.4-12.1,4.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1l0.1,4.3c-0.7-0.1-1.5-0.2-2.3-0.2l-0.1,0c-6.6,0-12,5.4-12.1,12             c0,3.2,1.2,6.3,3.5,8.6c2.3,2.3,5.3,3.6,8.5,3.6c0,0,0,0,0,0c2.9,0,5.7-1,8-2.9c2,0.4,4,0.7,6,0.7c0,0,0.1,0,0.2,0             c0.5,2.7,6.4,4,11.9,4c5.8,0,12-1.4,12-4.4v-5.5V34C57,33.9,57,33.7,56.9,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2A63B",
    d: "M56,39.4v5.5c0,1.9-5,3.4-11,3.4c-6.1,0-10.9-1.5-10.9-3.3v-0.6l-0.1-4.3H34c0.8,1.6,5.4,2.8,10.8,2.8             c5.5,0,11.1-1.5,11.1-3.4H56L56,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B844",
    d: "M44.7,19.1v5.4h-0.1c0,1.9-5.1,3.4-11.1,3.4c-2.3,0.1-4.7-0.2-7-0.8l-0.1,0.1c-1.1-0.9-2.4-1.7-3.8-2.1V25             l-0.2-5.7c0.4,1.8,5.2,3.1,11,3.1s11.2-1.5,11.2-3.4H44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEDB41",
    d: "M44.7,19.2L44.7,19.2c0,1.9-5.1,3.3-11.2,3.3c-6.1,0-10.7-1.4-11-3.1c0-0.1-0.1-0.2-0.1-0.2             c0-1.9,4.9-3.4,11.1-3.4C39.6,15.7,44.7,17.3,44.7,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B844",
    d: "M34,39.9L34,39.9l-0.1-1.1l-0.1-4.6c0.4,1.8,5.2,3.1,11,3.1c5.8,0,11-1.5,11.1-3.3H56v5.4h-0.1             c0,1.9-5,3.4-11.1,3.4C38.7,42.8,34.8,41.5,34,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2A63B",
    d: "M26.6,43.4c1.4-1.3,2.5-2.9,3-4.7h0.3c1.1,0.1,2.3,0.2,3.5,0.2h0.5v1.1l0.1,4.3h-0.6             c-2.3,0.1-4.5-0.2-6.7-0.7L26.6,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B844",
    d: "M34,33.8V34l0.1,4.8h-0.5c-1.3,0-2.5-0.1-3.6-0.2h-0.3c0.4-1.1,0.5-2.2,0.5-3.4c0-0.8-0.1-1.5-0.3-2.2h0.3             c1.1,0.1,2.2,0.2,3.4,0.2l0.5,0.3C34,33.6,34,33.7,34,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2A63B",
    d: "M26.5,27.1c2.3,0.6,4.6,0.8,7,0.8c6,0,11.1-1.5,11.1-3.4h0.1v6.1c-5.6,0-10.2,1.3-10.8,3l-0.5-0.3             c-1.1,0-2.2-0.1-3.2-0.2h-0.3c-0.5-2.4-1.7-4.5-3.6-6L26.5,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEDB41",
    d: "M30,33.2L30,33.2c-0.5-2.4-1.8-4.5-3.7-6.1c-1.1-1-2.5-1.8-3.9-2.2c-1-0.4-2.2-0.5-3.2-0.5             c-6.1-0.1-11.1,4.8-11.2,11c-0.1,6.1,4.8,11.1,11,11.2c2.8,0,5.5-1,7.6-2.9c1.4-1.3,2.5-3,3.1-4.9c0.4-1.1,0.5-2.2,0.5-3.3             C30.2,34.7,30,33.9,30,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEDB41",
    d: "M55.9,33.9V34c-0.2,1.8-5.2,3.3-11.1,3.3c-6,0-10.6-1.4-11-3.1v-0.3c0-0.1,0-0.2,0.1-0.3             c0.6-1.7,5.2-3,10.8-3h0.2C50.9,30.6,55.9,32.1,55.9,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2A63B",
    d: "M19.2,34.1c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.6,0.5,1,1,1s1-0.5,1-1             c0-1.6-1.1-3.1-2.7-3.6v-0.4c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1v0.4c-1.7,0.4-2.8,1.9-2.7,3.6c0,2.1,1.7,3.8,3.8,3.8             c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7l0,0c-0.9,0-1.7-0.8-1.7-1.7c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1c0,1.7,1.1,3.1,2.7,3.6             v0.8c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1v-0.8c2-0.6,3.1-2.7,2.5-4.7C22.3,35.2,20.8,34.1,19.2,34.1z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "_btn11",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_menu",
    style: {
      fill: "#FFFFFF"
    },
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 0.7,
    width: 80,
    height: 44,
    x: -8,
    y: 10
  })), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn12",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,10.3C31.5,10.3,31.5,10.3,31.5,10.3c-0.4,0-0.9,0-1.3,0 c-15.9,0.2-28.6,4.6-28.6,10c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0.1,0.2c0.5,2,2.8,3.8,6.3,5.3v31.1 c0.8,0,1.6,0,2.4,0c0-10.1,0-20.1,0-30.2c0,0,0,0,0,0c1.9,0.6,4,1.2,6.3,1.6c0.5,0.1,0.9,0.2,1.3,0.2v19.6c0.8,0,1.5,0,2.4,0 c0-6.4,0-12.8,0-19.2c3,0.4,6.3,0.6,9.6,0.7c0.9,0,1.8,0,2.7,0c3.4,0,6.7-0.3,9.7-0.7c0,6.5,0,12.8,0,19.2c0.8,0,1.4,0,2.1,0V29.3 c3-0.5,5.8-1.2,8.1-2c0.1,0,0.2,0,0.3-0.1c0,10.2,0,20.3,0,30.4c0.7,0,1.3,0,2.1,0V26.4c3.4-1.5,5.5-3.3,6-5.2c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.3,0.1-0.4c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0C61.4,14.8,48,10.3,31.5,10.3z M31.5,28.4c-17,0-27.9-4.8-27.9-8 c0-3.3,10.9-8,27.9-8s27.9,4.8,27.9,8C59.4,23.6,48.6,28.4,31.5,28.4z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn13",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "17.9,31.8 25.4,43.2 27,42.2 19.6,30.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.5,28.3 31.9,39.7 32.5,39.2 25.2,27.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15,33.8 22.3,45.2 23.3,44.5 15.9,33.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.6,29.5 29,40.8 29.6,40.4 22.2,29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.3,34.8 20.7,46.2 21.4,45.7 14,34.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,42 10.2,53.4 11.4,52.3 4.9,41.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.2,40.5 13.3,51.5 14,51 6.5,39.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.3,28.2 33.7,39.5 35.5,38.4 28.1,27.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.5,38 15.8,49.4 16.9,48.8 9.4,37.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.7,36.5 18.1,47.9 18.8,47.5 11.4,36.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1,24.9c-0.1-0.1-0.1-0.1-0.2-0.2c-0.9-1-2.5-2.6-2.8-3.1c-0.4-0.8-0.8-2.3-1-3.6c-0.2-1-0.3-2-0.7-2.7 c-0.5-1.1-2.7-3.1-3.5-3.9c-0.4-0.5-1.1-0.9-1.7-0.9c-0.3,0-0.8,0.1-1.1,0.3L50,10.9c-0.1,0.1-7.6,6.6-10.5,8.1 c-2.5,1.3-6.3,2.7-10.2,4.1c-4.9,1.6-9.8,3.5-13,5.4c-3.7,2.4-14.5,11-15,11.3c-1,0.7-1.2,2-0.7,2.9l7.8,13.3 c0.1,0,0.1,0.1,0.1,0.1c0.4,0.5,1.1,0.9,1.8,0.9c0.3,0,0.8-0.1,1.1-0.2l0.1-0.1c0.1-0.1,10.5-8.6,13.9-10.5c3-1.7,7.8-3.6,12.4-5.2 c4.3-1.6,8.4-3,11.1-4.6c3.3-1.7,11.2-8.5,11.5-8.7C61.4,27.2,61.6,25.9,61.1,24.9z M59.8,27c0,0-8.1,6.8-11.4,8.6 c-5.7,3.1-17.6,6.3-23.4,9.8c-3.5,2.1-14,10.6-14,10.6c-0.5,0.3-1.2,0.1-1.5-0.3L1.6,42.3c-0.3-0.5-0.1-1.2,0.3-1.5 c0,0,11.2-8.9,14.9-11.2c5.7-3.5,17.4-6.5,23.1-9.5c3-1.6,10.7-8.2,10.7-8.2c0.5-0.3,1.2-0.1,1.5,0.3c0,0,2.8,2.6,3.3,3.6 c0.5,1.5,0.8,4.8,1.6,6.4c0.5,0.9,3,3.4,3,3.4C60.4,26,60.2,26.6,59.8,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2,17.5c-0.8,1.4-0.7,3,0.1,4.3l1.5,2.7c0.3-0.3,0.8-0.4,1.1-0.1c0.3,0.3,0.4,0.8,0.1,1.1l-0.3,0.3 c-0.1,0-0.2-0.1-0.3-0.1c-1.4-0.6-2.5-1.6-3.4-2.8l-2-2.8c-0.3-0.5-0.9-0.9-1.4-1c-0.1,0.5,0.1,1.2,0.4,1.6l2.2,2.7 c0.9,1.2,1.5,2.6,1.6,4.1c0,0.1,0,0.2,0,0.3l-0.3,0.2c-0.3,0.1-0.8,0-1-0.4c-0.1-0.3,0-0.8,0.4-1l-2.2-2.4 c-1.1-1.2-2.6-1.7-4.1-1.5l6.5,8.9l2.1-1.5c0.8,0.8,1.6,1.2,2.7,1.2c0.3,0,0.5,0,0.8,0.1c0-0.3,0-0.5,0.1-0.8 c0.3-1,0.2-2.1-0.2-2.9l2.1-1.4L47.2,17.5z M49.1,23.6l-1.2-2.2c-0.4-0.8-0.7-1.5-0.5-2.3l3.4,4.6l-0.4,0.2 C50,23.7,49.6,23.5,49.1,23.6z M49.9,27.1V27c0.2,0.2,0.4,0.4,0.7,0.6l-0.8,0.7C49.6,27.9,49.6,27.4,49.9,27.1z M41.4,23.6 c0.8,0.2,1.4,0.6,2,1.2l1.8,1.8c-0.2,0.4-0.2,0.9-0.1,1.3l-0.3,0.2L41.4,23.6z M46.4,30.7l-1.3-1.8l0.3-0.2c0,0.1,0.1,0.2,0.2,0.2 c0.4,0.2,0.9,0.2,1.3,0l0.3-0.1c0.1,0.3,0.3,0.7,0.5,1L46.4,30.7z M47.3,25.3c0.7,0.5,1.3,0.9,2,1.2c0.1,0,0.1,0,0.1,0 c-0.3,0.2-0.4,0.7-0.4,1c-0.3,0-0.8,0-1.1,0.1C47.7,26.9,47.5,26.1,47.3,25.3z M48,28.4c0.4-0.2,0.9-0.1,1.1,0.3l-0.8,0.5 C48.3,29,48,28.7,48,28.4z M48.9,29.8l0.7-0.5l1,1.3C49.9,30.4,49.3,30.2,48.9,29.8z M51.2,30.1l-1-1.3l0.8-0.5 C51.2,28.8,51.3,29.5,51.2,30.1z M51.2,27.2c-0.2-0.2-0.4-0.5-0.8-0.8l0.2-0.2c0.3-0.4,0.4-0.9,0.3-1.3c0-0.1-0.1-0.2-0.1-0.3 l0.3-0.2l1.4,1.8L51.2,27.2z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn14",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,6H35l-3,9l5,6l-2,8l2,4l-3,9l3,3l-3,6l3,7h13c2.2,0,4-1.8,4-4V15L45,6z M52,54c0,1.1-0.9,2-2,2H38l-2-5l3-6l-3-3l3-9 l-2-4l2-8l-5-6l2-7h7v5c0,2.2,1.8,4,4,4h5V54z M47,15c-1.1,0-2-0.9-2-2l0-5l7,7L47,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,29l2-8l-5-6l3-9H14c-2.2,0-4,1.8-4,4v44c0,2.2,1.8,4,4,4h18l-3-7l3-6l-3-3l3-9L30,29z M27,42l3,3l-3,6l2,5H14 c-1.1,0-2-0.9-2-2V10c0-1.1,0.9-2,2-2h14l-3,7l5,6l-2,8l2,4L27,42z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn15",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_qr",
    width: 36,
    height: 36,
    x: 16,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ok",
    fill: "#A0F065",
    stroke: "#000",
    strokeWidth: 2,
    strokeOpacity: 1,
    width: 36,
    height: 36,
    x: 10,
    y: 20
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn16",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_qr",
    width: 36,
    height: 36,
    x: 16,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    fill: "#F06565",
    stroke: "#000",
    strokeWidth: 2,
    strokeOpacity: 1,
    width: 30,
    height: 30,
    x: 12,
    y: 20
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn17",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_qr",
    width: 36,
    height: 36,
    x: 12,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_pencil",
    width: 48,
    height: 48,
    x: 20,
    y: 14
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn18",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,30.8c-0.1-1.9-0.7-3.3-1.8-4L28.3,11c-0.8-0.6-1.8-1-2.8-1C23,10,21,12,21,14.5l0.1,34.3c0,2.5,2,4.5,4.5,4.5 c1.1,0,2.1-0.4,2.8-1l20.9-16C50.7,35.1,51.1,32.5,51,30.8z M48,34.7l-20.8,16c-1.7,1.4-4.1,0.2-4.1-1.9L23,14.5 c0-2.1,2.4-3.2,4.1-1.9L48,28.4C49.4,29.3,49.2,33.7,48,34.7z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn19",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,30.8c-0.1-1.9-0.7-3.3-1.8-4L35.3,11c-0.8-0.6-1.8-1-2.8-1 C30,10,28,12,28,14.5l0,2.3L20.3,11c-0.8-0.6-1.8-1-2.8-1C15,10,13,12,13,14.5l0.1,34.3c0,2.5,2,4.5,4.5,4.5c1.1,0,2.1-0.4,2.8-1 l7.7-5.9l0,2.4c0,2.5,2,4.5,4.5,4.5c1.1,0,2.1-0.4,2.8-1l20.9-16C57.7,35.1,58.1,32.5,58,30.8z M19.2,50.7c-1.7,1.4-4.1,0.2-4.1-1.9 L15,14.5c0-2.1,2.4-3.2,4.1-1.9l8.9,6.7l0.1,24.5L19.2,50.7z M55,34.7l-20.8,16c-1.7,1.4-4.1,0.2-4.1-1.9L30,14.5 c0-2.1,2.4-3.2,4.1-1.9L55,28.4C56.4,29.3,56.2,33.7,55,34.7z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn20",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5,10c-1,0-2,0.3-2.8,1L15.8,26.8c-1.1,0.7-1.7,2.1-1.8,4c-0.1,1.8,0.3,4.3,1.7,5.5l20.7,16c0.8,0.7,1.8,1.1,2.9,1.1 c0,0,0,0,0,0c1.2,0,2.3-0.4,3.1-1.3c0.9-0.8,1.4-2,1.4-3.2L44,14.5C44,12,42,10,39.5,10z M41.9,48.8c0,2.1-2.4,3.3-4.1,1.9L17,34.7 c-1.2-1-1.4-5.4,0-6.3l20.9-15.8c1.7-1.3,4.1-0.2,4.1,1.9L41.9,48.8z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn21",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5,10c-1,0-2,0.3-2.8,1L36,16.8l0-2.3c0-2.5-2-4.5-4.5-4.5c-1,0-2,0.3-2.8,1L7.8,26.8 c-1.1,0.7-1.7,2.1-1.8,4c-0.1,1.8,0.3,4.3,1.7,5.5l20.7,16c0.8,0.7,1.8,1.1,2.9,1.1c0,0,0,0,0,0c1.2,0,2.3-0.4,3.1-1.3 c0.9-0.8,1.4-2,1.4-3.2l0-2.4l7.6,5.9c0.8,0.7,1.8,1.1,2.9,1.1c0,0,0,0,0,0c1.2,0,2.3-0.4,3.1-1.3c0.9-0.8,1.4-2,1.4-3.2L51,14.5 C51,12,49,10,46.5,10z M33.9,48.8c0,2.1-2.4,3.3-4.1,1.9L9,34.7c-1.2-1-1.4-5.4,0-6.3l20.9-15.8c1.7-1.3,4.1-0.2,4.1,1.9L33.9,48.8z  M48.9,48.8c0,2.1-2.4,3.3-4.1,1.9l-8.9-6.8L36,19.3l8.9-6.7c1.7-1.3,4.1-0.2,4.1,1.9L48.9,48.8z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn22",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2,24.4c-0.7-1.6-2.3-2.6-4.1-2.6l-34.3-0.1c-1.7,0-3.2,0.9-4,2.5c-0.8,1.6-0.6,3.4,0.5,4.8l15.8,20.9 c1.1,1.6,3.3,1.8,4.6,1.8c0.8,0,3.6-0.1,4.9-1.8l16-20.7C53.7,27.8,53.9,26,53.2,24.4z M51,27.9L35,48.7c-1,1.2-5.4,1.4-6.3,0 L12.9,27.8c-1.3-1.7-0.2-4.1,1.9-4.1l34.3,0.1C51.2,23.8,52.4,26.2,51,27.9z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn23",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6,28.3l-2.4,0l5.9-7.6c1.1-1.4,1.4-3.2,0.6-4.8c-0.7-1.6-2.3-2.6-4.1-2.6l-34.3-0.1 c-1.7,0-3.2,0.9-4,2.5c-0.8,1.6-0.6,3.4,0.5,4.8l5.8,7.7l-2.3,0c-1.7,0-3.2,0.9-4,2.5c-0.8,1.6-0.6,3.4,0.5,4.8l15.8,20.9 c1.1,1.6,3.3,1.8,4.6,1.8c0.8,0,3.6-0.1,4.9-1.8l16-20.7c1.1-1.4,1.4-3.2,0.6-4.8C52.9,29.3,51.4,28.3,49.6,28.3z M13.4,19.3 c-1.3-1.7-0.2-4.1,1.9-4.1l34.3,0.1c2.1,0,3.3,2.4,1.9,4.1l-6.8,8.9l-24.5-0.1L13.4,19.3z M51.5,34.4l-16,20.8c-1,1.2-5.4,1.4-6.3,0 L13.4,34.3c-1.3-1.7-0.2-4.1,1.9-4.1l34.3,0.1C51.7,30.3,52.9,32.7,51.5,34.4z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn24",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6,35.3l-16-20.9c-1.3-1.6-4.1-1.7-4.9-1.7c-1.3,0-3.5,0.2-4.6,1.8L11.3,35.4c-1.1,1.4-1.3,3.3-0.5,4.8 c0.8,1.5,2.3,2.5,4,2.5h0l34.3-0.1c1.8,0,3.3-1,4.1-2.6C53.9,38.4,53.7,36.6,52.6,35.3z M49.1,40.6l-34.3,0.1 c-2.1,0-3.2-2.4-1.9-4.1l15.8-20.9c0.9-1.4,5.3-1.2,6.3,0l16,20.8C52.4,38.2,51.2,40.6,49.1,40.6z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn25",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2,36.1l2.4,0c1.8,0,3.3-1,4.1-2.6c0.7-1.6,0.5-3.4-0.6-4.8L37,7.9c-1.3-1.6-4.1-1.7-4.9-1.7 c-1.3,0-3.5,0.2-4.6,1.8L11.8,28.9c-1.1,1.4-1.3,3.3-0.5,4.8c0.8,1.5,2.3,2.5,4,2.5h0l2.3,0l-5.8,7.7c-1.1,1.4-1.3,3.3-0.5,4.8 c0.8,1.5,2.3,2.5,4,2.5h0l34.3-0.1c1.8,0,3.3-1,4.1-2.6c0.7-1.6,0.5-3.4-0.6-4.8L47.2,36.1z M15.3,34.2c-2.1,0-3.2-2.4-1.9-4.1 L29.2,9.2c0.9-1.4,5.3-1.2,6.3,0l16,20.8c1.4,1.7,0.2,4.1-1.9,4.1L15.3,34.2z M49.6,49.1l-34.3,0.1c-2.1,0-3.2-2.4-1.9-4.1l6.7-8.9 l24.5-0.1l6.8,8.9C52.9,46.7,51.7,49.1,49.6,49.1z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "_btn26",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7,18.7c-3.6,0-6.6,2.9-6.6,6.5c0.1,3.6,2.9,6.5,6.5,6.5c3.6,0,6.5-2.9,6.6-6.5 C39.2,21.6,36.3,18.7,32.7,18.7z M32.6,29.7c-2.5,0-4.4-2-4.5-4.5c0-2.5,2.1-4.5,4.6-4.5c2.5,0,4.5,2,4.5,4.4 C37.1,27.7,35.1,29.7,32.6,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,55.8c0,0,6.8-8.8,9.8-13.7c2.7-4.6,5.3-9.7,5.9-15.1c0.6-5.5-1.4-10.9-5.1-14.9 c-3.7-4-9.1-6.2-14.5-6.1C20.6,6.2,11.7,17.1,13.7,28.5c1,5.5,3.9,10.7,6.8,15.4c2.5,4.1,5.4,7.9,8.3,11.6c1.2,1.5,2.4,2.9,3.6,4.4 C33.6,58.7,36.2,55.8,36.2,55.8z M32.6,56.9C27,50.5,21.9,43.5,18.3,35.8c-2.4-5.1-3.9-10.6-2-16.2c1.7-5,5.6-8.9,10.6-10.7 c6.8-2.4,14.8-0.2,19.3,5.6c3.7,4.4,4.5,10.2,3,15.6c-2.9,9.2-14.7,24.5-14.7,24.5L32.6,56.9z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc1",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "1"))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "2"))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc3",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "3"))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc4",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "4"))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc5",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "5"))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc6",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "6"))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc7",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "7"))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc8",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "8"))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc9",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "9"))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calc0",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 50,
    fontSize: 52,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, "0"))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calcd",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("text", {
    x: 23,
    y: 40,
    fontSize: 68,
    fontWeight: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    stroke: "#000",
    strokeWidth: 1,
    strokeOpacity: 1
  }, ","))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "_calcx",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11.3,59.7 33.8,37.2 56.4,59.7 61.7,54.4 39.1,31.9 61.7,9.3 56.4,4.1 33.8,26.6 11.3,4.1 6,9.3 28.6,31.9 6,54.4 "
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "_calco",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ok",
    style: {
      fill: "#A0F065"
    },
    stroke: "#000",
    strokeWidth: 2,
    strokeOpacity: 1,
    width: 42,
    height: 42,
    x: 11,
    y: 12
  })), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "_key_b",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3,41.7l6.5-6.5l6.6,6.5l3.3-3.3l-6.6-6.5l6.6-6.6l-3.3-3.2l-6.6,6.5l-6.5-6.5L27,25.3l6.6,6.6L27,38.4L30.3,41.7 L30.3,41.7z M20.5,12L3,32.2l17.5,19.6H60V12H20.5z M55.4,47.2H22.6l-13.4-15l13.5-15.5h32.7V47.2z"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "_key_s",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9,1.1L10.7,24.7c-1.5,2-0.2,4.7,2.2,4.7h4.8c1.6,0,3,1,3,2.6v29.1c0,1.5,1.1,2.8,2.7,2.8h18c1.5,0,2.8-1.2,2.8-2.8             V32.1c0-1.6,1.2-2.6,2.8-2.6h4.8c2.4,0,3.7-2.8,2.2-4.7L36.1,1.1C35-0.5,30-0.3,28.9,1.1z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "_key_c",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_menu",
    style: {
      fill: "#FEDB41"
    },
    stroke: "#FEDB41",
    strokeWidth: 1,
    strokeOpacity: 1,
    width: 96,
    height: 96,
    x: -18,
    y: -19
  })), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_503",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9,1c10,0,20,0,30,0C47,1,47,1.1,47.1,1.1c0.9,0.1,1.7,0.3,2.4,0.8             c2.6,1.4,3.9,3.6,3.9,6.6c0,3.7,0,7.5,0,11.2c0,0.1,0,0.3,0,0.5c0.2,0,0.4,0,0.6,0c1.1,0,2.2,0,3.3,0.2c3.1,0.5,5.7,3.3,5.8,6.7             c0.1,4.9,0,9.7,0,14.6c0,1.1-0.2,2.1-0.7,3.1c-1.1,2.2-2.8,3.6-5.2,3.9c-1.1,0.2-2.2,0.1-3.2,0.1c-0.2,0-0.3,0-0.5,0             c0,0.2,0,0.3,0,0.4c0,2.2,0,4.4,0,6.7c0,2-0.7,3.7-2.1,5.1C49.8,62.3,48.1,63,46,63c-9.5,0-19,0-28.5,0c-1.6,0-3.1-0.5-4.4-1.5             c-1.8-1.5-2.7-3.4-2.8-5.7c0-2.2,0-4.4,0-6.6c0-0.1,0-0.3,0-0.4c-0.2,0-0.3,0-0.4,0c-0.9,0-1.8,0-2.7-0.1c-3-0.4-4.9-2.1-6-4.9             c-0.2-0.5-0.2-1-0.4-1.5C1,37,1,31.7,1,26.5c0,0,0.1-0.1,0.1-0.1C1.4,23.9,2.7,22,5,20.8c1-0.5,2-0.8,3.1-0.7c0.8,0,1.6,0,2.4,0             c0-0.2,0-0.3,0-0.4c0-3.8,0-7.6,0-11.4c0-3.2,2-6,5.1-6.9C16,1.2,16.4,1.1,16.9,1z M15.2,36.8c0,0.1,0,0.2,0,0.3             c0,6.3,0,12.5,0,18.8c0,1.3,1,2.3,2.3,2.3c1.7,0,3.4,0,5.2,0c4.8,0,9.6,0,14.4,0c3,0,6,0,9,0c1.5,0,2.4-1,2.4-2.5             c0-0.7,0-1.4,0-2.1c0-5.1,0-10.2,0-15.4c0-0.5,0-1,0-1.5C37.5,36.8,26.4,36.8,15.2,36.8z M48.6,20.1c0-0.2,0-0.3,0-0.4             c0-3.8,0-7.5,0-11.3c0-1.5-1.1-2.6-2.6-2.6c-9.4,0-18.8,0-28.2,0c-1.6,0-2.6,1-2.6,2.5c0,3.8,0,7.6,0,11.4c0,0.1,0,0.2,0,0.3             C26.4,20.1,37.5,20.1,48.6,20.1z M52.2,24.8c-2,0-3.6,1.6-3.6,3.6c0,2,1.7,3.5,3.7,3.5c1.9,0,3.5-1.6,3.5-3.6             C55.8,26.4,54.2,24.8,52.2,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9,41.5c0,1.6,0,3.1,0,4.7c-7.9,0-15.8,0-23.8,0c0-1.6,0-3.1,0-4.7C28,41.5,35.9,41.5,43.9,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,53.4c0-1.6,0-3.1,0-4.7c5.5,0,11.1,0,16.7,0c0,1.6,0,3.1,0,4.7C31.2,53.4,25.7,53.4,20.1,53.4z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "_send",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7,3c0.1,0.1,0.4,0.1,0.8,0.2c20,9.1,40.1,18.1,60.1,27.2 c0.5,0.2,0.9,0.7,1.2,1.1c0.5,0.8,0.2,1.8-0.8,2.2c-2.7,1.2-5.3,2.4-8,3.6C37.7,45.2,20.4,53.1,3.1,60.9c-0.5,0.2-1,0.4-1.5,0.4 c-1.3-0.1-1.9-1-1.4-2.2c1.1-3,2.2-6,3.3-9c2.1-5.7,4.2-11.4,6.3-17.1c0.2-0.5,0.2-1,0-1.5c-3.2-8.7-6.4-17.4-9.6-26 C-0.3,4.1,0.3,3,1.7,3z M4.2,7.6C4.4,8,4.4,8.2,4.5,8.4c2.7,7.2,5.3,14.3,7.9,21.5c0.2,0.6,0.5,0.8,1.2,0.8c13.5,0,27.1,0,40.6,0 c0.2,0,0.5,0,0.7,0c0-0.1,0-0.1,0-0.2C38.1,22.9,21.3,15.3,4.2,7.6z M4.2,56.9c17.1-7.8,33.9-15.4,50.8-23c0,0,0-0.1,0-0.2 c-0.2,0-0.4,0-0.5,0c-13.7,0-27.3,0-41,0c-0.6,0-0.8,0.2-0.9,0.7c-2.3,6.3-4.7,12.6-7,18.9C5.1,54.5,4.7,55.6,4.2,56.9z"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "_menu2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 34,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 34,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 34,
    r: 6
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "_menu3",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 12,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 32,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 52,
    r: 6
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "_cal2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1,26.2c-0.8,0-1.4-0.2-1.8-0.8C18,25,18,24.6,18,24.2V10.6c0-1,0.5-1.7,1.4-2c0.3-0.1,0.6-0.1,0.9-0.1h23.5 c0.4,0,0.7,0,1.1,0.1c0.9,0.2,1.4,0.9,1.4,1.9v13.7c0,1.2-0.9,2-1.9,2H20.1z M19.7,10.4v14h24.6v-14H19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2,46c-2.2,0-4.4,0-6.7,0c0-1.4,0-2.8,0-4.3c2.2,0,4.5,0,6.7,0C35.2,43.2,35.2,44.6,35.2,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8,56c-2.2,0-4.3,0-6.5,0c0-1.4,0-2.9,0-4.3c2.2,0,4.3,0,6.5,0C45.8,53.1,45.8,54.5,45.8,56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,31.7c2.3,0,4.5,0,6.7,0c0,1.4,0,2.8,0,4.2c-2.2,0-4.4,0-6.7,0C28.5,34.6,28.5,33.2,28.5,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8,35.9c-2.2,0-4.3,0-6.5,0c0-1.4,0-2.8,0-4.2c2.2,0,4.3,0,6.5,0C45.8,33,45.8,34.4,45.8,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2,56c-2.2,0-4.4,0-6.7,0c0-1.4,0-2.8,0-4.3c2.2,0,4.5,0,6.7,0C35.2,53.2,35.2,54.6,35.2,56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,56c-2.2,0-4.4,0-6.7,0c0-1.4,0-2.8,0-4.3c2.2,0,4.5,0,6.7,0C24.7,53.2,24.7,54.6,24.7,56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,46.1c-2.2,0-4.4,0-6.7,0c0-1.4,0-2.8,0-4.3c2.2,0,4.5,0,6.7,0C45.9,43.3,45.9,44.7,45.9,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,46.1c-2.2,0-4.4,0-6.7,0c0-1.4,0-2.8,0-4.3c2.2,0,4.5,0,6.7,0C24.7,43.3,24.7,44.7,24.7,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,36c-2.2,0-4.4,0-6.7,0c0-1.4,0-2.8,0-4.3c2.2,0,4.5,0,6.7,0C24.7,33.2,24.7,34.5,24.7,36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2,0.8H19c-6.6,0-9,2.4-9,9v44.6c0,6.6,2.4,9,9,9h26.2c6.6,0,8.8-2.4,8.8-9V9.8C54,3.2,51.9,0.8,45.2,0.8z M45.7,61.6H19 c-6.6,0-7-5-7-5V8.5c0,0-0.6-6,6-6c0,0,23.5,0,28.7,0c6,0,5.3,6,5.3,6v48.1C52,56.6,51.8,61.7,45.7,61.6z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "_cut2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,38v-9c0,0,0.7-1.1,1-1c1,0.2,1,3,3,3c1.7,0,3-1,3-6s-1.3-6-3-6c-2,0-2,2.8-3,3c-0.3,0.1-1-1-1-1s0-4.7,0-6c0-2-2-2-2-2 H2c0,0-2-0.1-2,2v47c0,2,2,2,2,2h43c0,0,2,0,2-2c0-3.7,0-16.5,0-22c0-1.9-2-2-2-2h-4.9c0,0-1.1-0.7-1-1c0.2-1,3-1,3-3c0-1.7-1-3-6-3 s-6,1.3-6,3c0,2,2.8,1.9,3,3c0.1,0.3-1,1-1,1H24z M45,62H2V15h20c0,0-0.1,5.3,0,7c0.1,1.9,2,2,2,2s1.4,0.2,2,0c0.7-0.2,1.1-2.2,2-2 c0.8,0.2,1,2.2,1,3s-0.2,2.8-1,3c-0.9,0.2-1.3-1.8-2-2c-0.5-0.2-2,0-2,0s-1.9,0-2,2c-0.1,2.5,0,7.3,0,10c0,1.9,2,2,2,2 s7.4,0.1,9.1,0c1.9-0.1,2-2,2-2s0.2-1.4,0-2c-0.2-0.7-2.2-1.1-2-2c0.2-0.8,2.2-1,3-1c0.8,0,2.8,0.2,3,1c0.2,0.9-1.8,1.3-2,2 c-0.2,0.5,0,2,0,2s0,1.9,2,2c2.5,0.1,5.9,0,5.9,0V62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6,4.5L41,0.1c0,0-1.8-0.4-2.4,1.5c-0.5,1.7-1.5,6.8-1.5,6.8c-0.3,1.9,1.5,2.4,1.5,2.4s1.3,0.5,2,0.4 c0.7-0.1,1.5-1.9,2.4-1.5c0.7,0.3,0.5,2.4,0.4,3.1c-0.2,0.8-0.8,2.7-1.6,2.7c-0.9,0.1-0.9-2-1.5-2.4c-0.5-0.3-2-0.4-2-0.4 s-1.9-0.4-2.4,1.5c-0.6,2.4-1.5,7.2-2.1,9.8c-0.4,1.9,1.5,2.4,1.5,2.4s7.1,1.6,8.8,1.9c1.9,0.3,2.5-1.5,2.5-1.5s0.5-1.3,0.4-2 c-0.1-0.7-1.9-1.5-1.5-2.4c0.3-0.7,2.4-0.5,3.1-0.4c0.8,0.2,2.7,0.8,2.7,1.6c0.1,0.9-2,0.9-2.4,1.5c-0.3,0.5-0.4,2-0.4,2 s-0.5,1.9,1.4,2.3c2.4,0.6,5.9,1.2,5.9,1.2s1.9,0.4,2.4-1.5c1.2-5.6,4-18.7,4.8-22.5C63.5,4.9,61.6,4.5,61.6,4.5z M56.4,28.9l-4.9-1 c0,0-0.9-0.9-0.8-1.2c0.5-1,3.1-0.4,3.6-2.3c0.3-1.6-0.4-3.1-5.2-4.2c-4.9-1-6.1,0-6.5,1.7c-0.4,2,2.3,2.5,2.3,3.6 c0,0.4-1.2,0.8-1.2,0.8l-7.8-1.7l1.9-8.8c0,0,0.9-0.8,1.2-0.7c1,0.5,0.4,3.1,2.3,3.5c1.6,0.3,3.1-0.4,4.2-5.2c1-4.9,0-6.1-1.7-6.5 c-2-0.4-2.5,2.3-3.6,2.3c-0.4,0-0.8-1.2-0.8-1.2l1.2-5.9l20.5,4.4L56.4,28.9z"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "_comm",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1,9.7c-12.8,0-23.4,8.4-23.5,18.8c0,6.3,4,12.3,10.5,15.7c-0.2,1.9-0.8,3.8-1.7,5.9l-1.5,3.5l3.8-0.8 c3.3-0.7,9.4-2.2,14.1-5.3l0.1,0c12.1-0.8,21.7-9.2,21.8-19.1C56.6,18.1,46.1,9.7,33.1,9.7z M34.7,45.6h-0.5l-0.4,0.2 c-4.2,2.9-9.9,4.4-13.5,5.2c0.7-1.7,1.6-3.9,1.9-6.5l0.2-1.2l-1-0.6c-6.1-3.1-9.6-8.5-9.6-14.1c0.1-9.3,9.7-16.8,21.5-16.8 c11.9,0,21.5,7.6,21.5,16.8C54.5,37.4,45.7,44.8,34.7,45.6z"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "_gst",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9,45.1c-0.2-2.5-1.2-5-2.5-6.2c-2.4-1.8-5.6-2.6-8.2-4.2c0,0,0.2-0.4,0.5-0.8c2.8-3.8,2.9-10.2,0.2-14.2 c-0.2-0.3-0.8-0.9-1.1-1.3c-1.9-1.8-4.4-1.9-6.7-1c-1.5,0.8-3.1,2.7-3.8,4.5l-0.2,0.8c-1.1-0.7-2.3-1.5-3.6-1.6 c-0.8-0.1-1.6,0-2.3,0.3c-0.3,0.1-2.2,1-2.2,1.1c-0.6-2.1-1-2.6-2.1-3.8c-1-1-1.8-1.4-3-1.7c-0.9-0.3-2.5-0.3-3.1-0.1 c-1.4,0.3-2.7,1.4-3.7,2.7c-1.7,2.6-2.5,6.3-1.7,9.7c0.3,1.8,1,3.2,1.9,4.4c0.2,0.4,0.5,0.6,0.5,0.6c-2.1,1.3-4.5,2.2-6.7,3.3 c-0.7,0.3-1.3,0.6-1.7,1.2c-1,1.1-1.7,2.6-2.1,4c-0.2,0.8-0.9,3,0,3.6c1.5,1.1,4,1.2,5.7,1.5c1.6,0.2,3.2,0.5,4.8,0.7v0.8 c-0.1,1.2,0,1.4,0.5,1.5c3.4,1.7,13.5,2.5,21.5,1.7c3.4-0.3,6.5-1,7.9-1.7c0.4-0.2,0.5-0.4,0.4-1.5v-0.9c1.8-0.5,3.7-0.3,5.6-0.6 c1.5-0.3,3.5-0.5,4.8-1.4l0.3-0.2L57.9,45.1z M39.6,19.6c1.3-1.2,2.5-1.6,4-1.2c1.8,0.5,3.5,2.7,4.2,5.3c0.4,1.8,0.5,4.1,0,5.8 c-0.4,1.8-1.2,3.2-2.3,4.3c-0.9,0.9-1.5,1.2-2.6,1.3c-1.2,0.1-1.9-0.1-2.7-1c-1.8-2-1-4.8-1.7-7.2c-0.4-1.3-1.3-2.3-1-3.7 C37.7,21.8,38.5,20.5,39.6,19.6C40.9,18.4,38.2,20.8,39.6,19.6z M33.3,22.9c3.2,1.2,5.1,7.5,3.5,12c-0.8,2.1-1.9,3.7-3.6,4.3 c-0.8,0.3-2,0.5-2.8,0.1c-1.2-0.5-2.1-1.5-2.9-3.2c-0.9-1.8-1.3-4.1-1.1-6.2c0.2-1.9,0.6-3.4,1.6-4.8C29.4,22.9,31.3,22.1,33.3,22.9 C36.5,24.1,31.3,22.1,33.3,22.9z M16.3,29.4c-0.3-1.1-0.4-3.5-0.2-4.6c0.5-3.2,2.3-5.8,4.4-6.5c0.5-0.1,1.5-0.1,2.4,0.3 c2.2,0.8,3.3,3.6,3.8,5.7c-1.1,2.4-1.9,4.6-1.8,7.3l0.1,1.2l-0.5,0.7c-0.8,1.1-0.9,1.2-1.7,1.4c-1.1,0.3-2.2,0.2-2.9-0.1 C18.4,33.8,16.9,31.8,16.3,29.4C16,28.3,16.9,31.8,16.3,29.4z M17.2,47c-3.3-0.4-6.4-0.8-9.6-1.6v-0.8c0.1-1.4,0.8-3.4,1.5-4.2 c1.1-1.1,2.8-1.7,4.2-2.3c1.7-0.7,3.3-1.5,4.9-2.3l0.5,0.2c1.1,0.5,2.6,0.8,3.7,0.4c0.5-0.1,0.9-0.3,1.3-0.5c0.3-0.2,0.8-1,1.2-1 c0.4,0.7,0.5,1.5,0.9,2.1c0.1,0.2,1.1,1.9,1.3,1.9c-0.4,0.4-1.4,0.7-1.9,0.9c-1,0.5-2.1,0.9-3.1,1.3c-1.3,0.6-2.5,1.1-3.3,2.3 c-0.5,0.7-1.4,2.4-1.6,3.1V47z M43.8,50.3c-6.2,1.6-17.7,1.6-23.9,0c-1.7-0.4-1.7-0.4-1.5-1.2c0.2-2.1,1.4-4.4,2.5-5.3 c2.1-1.4,4.8-2.1,7.1-3.2c1.2-0.5,2.1,0.1,3.3,0.3c1.3,0.3,2.5-0.1,3.7-0.6c1.3,0.7,2.7,1.3,4,2c1.6,0.8,3.6,1.5,5,2.7 c0.8,0.9,1.4,2.4,1.5,4.1C45.4,49.9,45.4,49.9,43.8,50.3C37.6,51.9,45.4,49.9,43.8,50.3z M56.2,45.4c-3.1,0.8-6.3,1.7-9.5,1.6 c-0.4-1.2-0.9-2.9-2-3.7c-1.3-1-3-1.7-4.5-2.4c-0.4-0.2-3.7-1.4-3.7-1.8c0.8-1.2,1.5-2.3,1.9-3.7l0.2-0.8l0.2,0.3 c0.2,0,0.5,0.3,0.8,0.6c1.1,1.2,3.4,1.5,5.3,0.4l0.8-0.3c1.6,0.8,3.3,1.5,4.9,2.3c1.3,0.6,3.2,1.2,4.1,2.3c0.8,0.8,1.5,2.8,1.6,4.2 L56.2,45.4L56.2,45.4z"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "_gst2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3,38.4c2.5,1.2,5.2,2.4,7.4,4.1c2.4,1.8,3.5,5.1,4.3,7.5l0.2,0.5l0.8,4.7l0,0.1c0.2,2,0.2,3.7-1.8,4.7 c-2.9,1.5-9.1,2.8-15.6,3.4c-3.9,0.4-8.2,0.6-12.7,0.6c0,0,0,0,0,0c-12.5,0-23.6-1.5-28.6-3.9c-2.5-0.6-2.3-2.9-2.2-4.7 c0-0.5,0-2.4,0.8-5.8c0.4-1.7,2.4-5.2,3.3-6.5c1.7-2.5,4.2-3.7,6.6-4.8l8-3.3c-2.8-3.8-4.3-8.8-4.3-14.1c0-11.4,7.2-20.7,16-20.7 c8.8,0,16,9.3,16,20.7c0,5.6-1.7,10.8-4.7,14.7L50.3,38.4z M8.8,54.9c0.4,0.1,0.9,0.2,1.4,0.3c5.5,1.4,13.5,2.2,22.1,2.2 c8.6,0,16.6-0.8,22-2.2c0.7-0.2,1.4-0.4,1.8-0.5c0,0,0,0,0,0c-0.2-2.5-1-4.9-2.3-6.3c-1.7-1.4-4.1-2.5-6.3-3.5 c-0.9-0.4-1.8-0.8-2.6-1.2c-1.2-0.7-2.5-1.3-3.7-1.9c-1-0.5-2.1-1-3.1-1.5c-0.1,0-0.3,0.1-0.3,0.1c-1.7,0.8-3.5,1.2-5.3,1.2 c-2,0-3.9-0.4-5.7-1.3c-0.4,0.1-0.7,0.2-1,0.3c-1.6,0.8-3.4,1.5-5.1,2.1c-2.7,1.1-5.6,2.2-7.9,3.7C11.2,47.7,9.2,51.5,8.8,54.9z  M32.5,7.4c-4.6,0-8.5,6-8.5,13.2s3.9,13.2,8.5,13.2c4.6,0,8.5-6,8.5-13.2S37.1,7.4,32.5,7.4z"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "_deliv",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2,23.8c0,0.8-0.8,0.9-0.8,0.9H8c0,0-0.8,0-0.8-0.9c0-0.8,0.7-0.9,0.7-0.9H12c0,0,0.6-0.2,0.5-1c0-1.1,0.4-2,1.4-2.5 c0.6-0.3,1.3-0.4,1.9-0.4h26.7c1.1,0,2.3,0.1,3.4,0.1c0.7,0,1.2,0.5,1.4,1.2c0.3,1,0.2,2,0.1,3c-0.1,0.5-0.1,1.1-0.2,1.7h5.6 c1.8-0.1,3.2,0.5,4.4,1.9l4.4,4.9c0.9,0.9,1.3,2,1.4,3.3L62.2,43c-0.1,0.8-0.5,1.4-1.3,1.6c-0.9,0.3-1.8,0.4-2.8,0.3 c-0.4,0-0.7,0.1-0.8,0.5c-0.8,1.6-1.9,2.9-3.8,3.4c-2.3,0.7-4.6-0.5-5.5-2.7c-0.1-0.2-0.2-0.5-0.2-0.7c-0.1-0.4-0.3-0.5-0.7-0.5 c-6.8,0-13.7,0-20.6,0c-0.4,0-0.6,0.1-0.7,0.5c-0.5,1.4-1.4,2.5-2.9,3.1c-1.4,0.5-2.8,0.6-4.1,0.1c-1.2-0.5-2-1.4-2.4-2.6 c-0.4-1.1-0.4-1.1-1.6-1.2c-0.8,0-1.6,0-2.4-0.1c-0.8,0-1.6-0.7-1.7-1.5c-0.1-0.7,0-1.4,0-2.1c0.1-1.4,0.3-1.8,0.4-3.2 c0.1-0.7,0.1-0.7-0.6-0.7c-2.8,0-5.7,0-8.5,0c-0.3,0-0.8-0.4-0.8-0.7c0-0.7,0.7-1,0.7-1H18c0.4,0,0.7,0.1,0.8,0.6 c0,0.5-0.2,0.8-0.6,1c-0.3,0.1-0.5,0.1-0.8,0.1c-1.1,0-2.2,0-3.3,0c-0.7,0-0.8,0.1-1,0.7l-0.6,4.3c0,0.6,0.2,0.8,0.8,0.8 c1,0,2,0,2.9,0c0.1,0,0.3-0.2,0.3-0.3c0.3-0.5,0.5-1.1,0.8-1.6c1.5-2.1,4.8-2.7,7-1.4c1.1,0.7,1.7,1.6,1.8,2.8 c0,0.3,0.2,0.4,0.5,0.4h16.2c0.8,0,0.9-0.1,1-0.9l2.1-20.2c0.1-0.8,0-0.9-0.8-0.9L15.6,21c-1,0.1-1.3,0.3-1.3,1.4c0,0.2,0,0.3,0,0.5 h9.1C23.4,22.9,24.2,22.7,24.2,23.8z M45.4,42.4c-0.1,0.4,0.1,0.7,0.5,0.7c0.4,0,0.8,0,1.2,0c0.6,0,0.7-0.2,0.9-0.7 c0.2-0.4,0.3-0.8,0.6-1.1c0.5-0.5,1.1-1.2,1.8-1.6c2.9-1.8,6.3-0.5,7.1,2.7c0.1,0.4,0.3,0.6,0.8,0.6c0.1,0,0.2,0,0.4,0 c1.4,0,1.6-0.1,1.8-1.5c0.2-1.8,0.4-3.7,0.6-5.5c0.1-1.1-0.1-2.1-0.9-3c-0.3-0.3-0.5-0.7-0.8-1c-1.2-1.5-2.3-2.9-3.8-4 c-1-0.7-2-1.1-3.3-1.1c-1.7,0.1-3.5,0-5.2,0L45.4,42.4z M21.2,40.6c-0.3,0.1-0.5,0.1-0.8,0.2c-1.5,0.5-2.7,2.5-2.4,4.1 c0.2,1.2,0.9,1.9,2.1,2.1c1.9,0.4,4-1.3,4-3.3C24.1,42.1,22.8,40.7,21.2,40.6z M52,47c0.3,0,0.6-0.1,0.8-0.1c1.8-0.4,3-1.8,2.9-3.5 c0-1.1-0.8-2.1-1.9-2.4c-2.3-0.7-4.7,1.5-4.3,3.8C49.9,46.3,50.6,46.9,52,47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,30.9c2.5,0,5,0,7.5,0c0.2,0,0.4,0,0.6,0c0.6,0.1,0.8,0.4,0.8,0.9c0,0.4-0.3,0.7-0.8,0.7c-0.2,0-0.4,0.1-0.6,0.1 c-5,0-9.9,0-14.9,0c-0.3,0-0.6,0-0.9-0.1c-0.4-0.1-0.5-0.4-0.5-0.8C6.5,31.3,6.7,31,7,31c0.3-0.1,0.6-0.1,0.8-0.1 C10.3,30.9,12.8,30.9,15.3,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,28.7c-2.2,0-4.4,0-6.6,0c-0.2,0-0.4,0-0.6-0.1c-0.5-0.1-0.7-0.3-0.7-0.8s0.2-0.7,0.8-0.8c0.2,0,0.4,0,0.6,0 c4.4,0,8.8,0,13.2,0c0.2,0,0.4,0,0.6,0c0.6,0.1,0.8,0.3,0.8,1c0,0.3-0.2,0.5-0.5,0.6c-0.2,0.1-0.5,0.1-0.7,0.1 C17.1,28.7,14.8,28.7,12.6,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,34.2c-3.1,0-6.1,0-9.1,0l0.4-4.4h4.9L58,34.2z"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "_stl",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,55.9c-6.8-7.6-1.4-9.9-4.1-13.9l-6.1-11L8.2,11.7C3.8,3.8,11.8-3.9,18.4,4.2l20.8,29.2c1.5,1.3,3,0.9,4.1,1.2 c4.7,1.7,5.5,5.5,6.4,8.7c1.4,5.2,1.5,10.8,7.6,12.2c2.8,0.6,7,3.4,3,6C55.5,64.6,47.2,64,41.8,63C38.3,62.3,33.8,61.3,29,55.9z  M30.9,45.6c-2,7,10.2,12.9,16.8,12.9c-3.1-1.4-10.6-5.4-10.4-9.5c0.2-4.4,10.1,5.5,11.2,6.1c-4.4-5.5-1.7-16.6-9-15.6 c3.2,4.6-3.1,3.1-4.6,2C34.4,46.4,32.7,46.3,30.9,45.6z M30.1,40l4.8-3.3l-3.2-5l-4.5,3.1L30.1,40z M25,31.2l4.5-2.9l-2.3-2.9 L23.2,28L25,31.2z M21.3,24.3L25,22L14.7,6.4c-1.5-2.3-4.2-0.1-3.1,1.9L21.3,24.3z"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "_mod",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4,19.2l-3.2,0.6L50.8,3.6L53.9,3c1.6-0.4,1.2-3-0.3-3L49,1 c-0.9,0.3-1.3,1.1-1.3,1.7l0.2,1.1l-24.4-1c-1.9-0.1-3.3,0.7-4.3,2.4L8.3,24c-1,1.7-0.9,3.6,0.2,5.1l8.4,10.8 c1.4,1.8,3.9,2.2,5.8,0.9c2-1.3,2.7-3.8,1.5-5.8l-4-6.9c-0.6-1-0.5-2,0.1-2.9l4.4-5.7c0.9-1.2,2.4-1.4,3.6-0.4 c0.7,0.6,1.4,1.1,2.1,1.7c1.1,0.9,1.4,1.8,0.9,3.2L27,35.2c-0.5,1.3-0.4,2.5,0.2,3.7c1.6,3,5.8,3.3,7.7,0.4l9-13.5 c0.6-1,1.4-1.7,2.5-2.2c2-0.8,5.2-2.5,5.2-2.5s0.3,0.6,0.4,1c0.2,0.6,0.9,0.8,1.6,0.7l4.1-0.8C59.5,21.7,59,18.9,57.4,19.2z  M44.4,21.4c-1,0.5-1.8,1.2-2.5,2.2l-9.4,14c-0.4,0.7-0.8,0.7-1.2,0.7c-0.1,0-0.2,0-0.3,0c-1-0.2-1.2-0.8-1.2-1 c-0.1-0.4,0-0.8,0.1-1.1L34,24.9c0.9-2.5,0.3-4.8-1.8-6.5L30,16.6c-1-0.8-2.2-1.2-3.4-1.2c-1.7,0-3.3,0.8-4.3,2.2l-4.4,5.8 c-1.4,1.9-1.5,4.3-0.3,6.3c1.2,2,2.5,4.2,4,6.7c0.3,0.6,0.1,1.4-0.5,1.8c-0.2,0.2-0.5,0.2-0.8,0.2c-0.4,0-0.8-0.2-1-0.5l-8.4-10.8 c-0.3-0.3-0.5-0.8,0-1.7l11-18.9c0.3-0.6,0.7-0.8,1.4-0.8l25.3,1l2.2,11.7L44.4,21.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 26.5,
    cy: 46.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 32.9,
    cy: 53,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 16.2,
    cy: 61.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 25.5,
    cy: 57.4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 35.6,
    cy: 62,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 19.4,
    cy: 52.2,
    r: 2
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_956",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6,31.3C59.2,37.2,55,42,49,44.3c-3.3,1.3-7,1.9-10.6,1.6 c-4-0.4-7.3-2.1-10.7-3.9c-3,3.2-6.1,6.3-9.2,9.4c-3.2,3.2-6.3,6.6-9.7,9.6c-1.4,1.2-2.9,2.6-4.8,1.9c-1.5-0.5-2.9-2-2.9-3.6 c0-1.8,0.9-2.8,2.1-4c1.6-1.6,3.2-3.2,4.8-4.8c3.2-3.3,6.5-6.5,9.7-9.8c1.5-1.5,2.9-2.9,4.4-4.4c-1.1-1.8-2.1-3.7-2.8-5.7 c-2.1-6.3-1.1-13.6,2.5-19.2c3.6-5.6,9.5-9.1,16-10c6.8-0.9,13.7,1.5,18.7,6.2C62.5,13.4,64.8,23.3,61.6,31.3 C58.4,39.5,62.3,29.4,61.6,31.3z M55.2,23.4c0-6.4-4.4-12.2-10.5-14c-6.1-1.8-12.8,0.7-16.3,6c-3.5,5.3-3.2,12.5,0.9,17.4 c3.4,4.2,8.9,6,14.2,5.1C50.3,36.6,55.2,30.3,55.2,23.4C55.3,15.4,55.2,33,55.2,23.4z"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "_cert",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4,61.6c-1-0.3-1.7-7-2.1-8.4c-1.5,0.2-9,1.1-9.4-0.7c-0.2-1.3,6.4-9.6,7.4-10.8c2.6-3,7.1-9.8,7.1-9.8 s-4.9,1.6-6.2,1.9c-3.4,0.6-7.6,0.8-10.2-2C-0.2,27.3,3.7,19.5,3,14.2C0.5-4.5,22.1,7.7,29,13.8c2-0.9,4.3-1,6.3-0.1 c6-5,12.7-9.5,20.9-9.5c4.5,0.7,6.5,1.7,5.3,13.2C62,22.1,62,22.2,62,27c0,0.1,0-0.7,0,0c-1.1,9.1-10.9,7.7-17.4,5.2 c1.5,3,5.1,8.2,7.3,10.8c1.1,1.3,8.2,8.2,8,9.3c-0.3,1.5-8.6,0.6-9.8,0.6c0,0-0.4,8.1-2.4,8.9c-0.9,0.3-9.3-7.5-15.4-25.9 C25.4,54.2,18,61.7,17.4,61.6z M26.1,18.1c-0.2-2-2.7-3.2-2.7-3.2s-3.4-2.4-6.6-4c-2.7-1.5-7.5-3-8.8-1.8c-1,0.9-0.3,5.9-0.2,7.7 C8,20.2,4.7,28.3,9.5,29.1c4.4,0.8,11-0.7,16-5.2c0.5-0.7,0.8-1.9,0.4-2.2c-4.1-0.5-8.7-1-9.2-3.3C16,14.7,26.1,18.1,26.1,18.1z  M39,23.6c4.5,4.4,8.3,5.7,14.5,6c5.5-0.1,3.6-5.8,3.4-11.8c-0.2-3.4,1-7.1-0.8-8.3c-2.9-1.8-8,0.8-8.8,1.2 c-3.7,1.5-4.9,2.7-7.9,5.3c-0.6,0.7-0.4,1.9-0.4,1.9s8.8-3.3,9.7-1c1,2.6-2.7,4-9.5,4.4C38.6,21.3,39,23.6,39,23.6z M12.6,49.2 c2.9-1,5.3-0.8,5.3-0.8s1.7,0.3,1.2,5.5c5.3-9,9.2-15.7,11.4-27.2c-0.4-0.2-0.4-0.2-1.2-0.6c-0.3,0.2,0.7,0.4,0,0 c-2.1,1.8-2.1,1.8-3.5,3.1C25.9,29.3,20.7,39.5,12.6,49.2z M35,26.2c-0.7,0.3-0.7,0.3-1.1,0.4c2.8,11.8,4.9,17.7,11.5,27.2 c0-3.2,0.8-5.6,0.8-5.6s1.6-0.7,4.8,0.1c-3.4-3.5-9.4-12.3-11.9-17.4C38.5,29.5,35,26.2,35,26.2z M29.3,19.6c0.1,4,2,4,3.2,3.9 c1.2-0.1,3,0,2.9-3.9c0-2.6-1.4-3.3-3.1-3.2C30.5,16.4,29.3,17.2,29.3,19.6z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "_stop",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z M2.7,32c0,3.5-0.1,6.9,0.1,10.4 c0.1,1.1,0.6,2.4,1.3,3.2c4.8,5,9.6,9.8,14.6,14.6c0.8,0.7,2.1,1.3,3.2,1.3c6.8,0.1,13.7,0.1,20.5,0c1.1,0,2.4-0.6,3.2-1.3 c4.9-4.8,9.7-9.7,14.6-14.6c0.9-0.9,1.3-1.9,1.3-3.2c0-6.9,0-13.9-0.1-20.8c0-1-0.4-2.1-1.1-2.8c-5-5.1-10-10.1-15-15 c-0.7-0.7-1.9-1.1-2.8-1.2c-6.9-0.1-13.9-0.1-20.8,0c-1,0-2.2,0.5-2.9,1.2c-5,4.8-9.8,9.8-14.7,14.7c-1,1-1.4,2-1.3,3.4 C2.8,25.2,2.7,28.6,2.7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4,27.8c-0.7,0-1.1,0-1.3,0.1v4.2c0.3,0.1,0.6,0.1,1.1,0.1c1.7,0,2.8-0.9,2.8-2.3C52.9,28.6,52,27.8,50.4,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,27.8c-2.2,0-3.4,2.1-3.4,4.8c0,2.7,1.3,4.7,3.4,4.7l0,0c2.2,0,3.4-2,3.4-4.8C40.4,30,39.2,27.8,37,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,22.5c-0.1-1-0.5-2.2-1.2-2.9c-4.3-4.4-8.7-8.7-13-13.1c-1-1-2.1-1.4-3.4-1.4c-6,0-12,0-18,0c-1.7-0.1-2.7,0.5-3.8,1.6 c-4.1,4.2-8.3,8.4-12.5,12.6c-1,1-1.5,2.1-1.5,3.5c0,6.1,0,12.1,0,18.1c0,1.4,0.5,2.6,1.5,3.6c4.3,4.3,8.6,8.5,12.8,12.8 c1,1,2.1,1.5,3.5,1.5c6.1-0.1,12.1,0,18.2-0.1c1.1,0,2.4-0.6,3.2-1.3c4.4-4.2,8.7-8.7,13.1-13c0.9-0.9,1.3-1.9,1.3-3.2 c0-3,0-6.1,0-9.1C58.8,29,58.8,25.8,58.6,22.5z M12.1,39.9c-1.6,0-3.2-0.4-4-0.9l0.7-2.6c0.8,0.4,2.2,0.9,3.5,0.9 c1.5,0,2.2-0.6,2.2-1.6c0-0.9-0.7-1.4-2.4-2c-2.4-0.8-3.9-2.1-3.9-4.2c0-2.4,2-4.2,5.4-4.2c1.6,0,2.8,0.3,3.6,0.7l-0.7,2.6 c-0.5-0.3-1.6-0.7-2.9-0.7c-1.4,0-2.1,0.7-2.1,1.4c0,0.9,0.8,1.3,2.6,2c2.5,0.9,3.7,2.2,3.7,4.2C17.8,37.9,15.9,39.9,12.1,39.9z  M29.7,28.2h-3.9v11.5h-3.2V28.2h-3.8v-2.7h10.9V28.2z M36.9,39.9L36.9,39.9c-4.2,0-6.7-3.2-6.7-7.2c0-4.2,2.7-7.4,6.9-7.4 c4.3,0,6.7,3.3,6.7,7.2C43.8,37.1,41,39.9,36.9,39.9z M54.8,33.2c-1.1,1-2.7,1.5-4.6,1.5c-0.4,0-0.8,0-1.1-0.1v5.1h-3.2v-14 c1-0.2,2.4-0.3,4.3-0.3c2,0,3.4,0.4,4.3,1.2c0.9,0.7,1.5,1.9,1.5,3.3C56.1,31.2,55.6,32.4,54.8,33.2z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "_stop1",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z M2.7,32c0,3.5-0.1,6.9,0.1,10.4 c0.1,1.1,0.6,2.4,1.3,3.2c4.8,5,9.6,9.8,14.6,14.6c0.8,0.7,2.1,1.3,3.2,1.3c6.8,0.1,13.7,0.1,20.5,0c1.1,0,2.4-0.6,3.2-1.3 c4.9-4.8,9.7-9.7,14.6-14.6c0.9-0.9,1.3-1.9,1.3-3.2c0-6.9,0-13.9-0.1-20.8c0-1-0.4-2.1-1.1-2.8c-5-5.1-10-10.1-15-15 c-0.7-0.7-1.9-1.1-2.8-1.2c-6.9-0.1-13.9-0.1-20.8,0c-1,0-2.2,0.5-2.9,1.2c-5,4.8-9.8,9.8-14.7,14.7c-1,1-1.4,2-1.3,3.4 C2.8,25.2,2.7,28.6,2.7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,22.6c-0.1-1-0.5-2.2-1.2-2.9c-4.3-4.4-8.7-8.7-13-13.1c-1-1-2.1-1.4-3.4-1.4c-6,0-12,0-18,0c-1.7-0.1-2.7,0.5-3.8,1.6 c-4.1,4.2-8.3,8.4-12.5,12.6c-1,1-1.5,2.1-1.5,3.5c0,6.1,0,12.1,0,18.1c0,1.4,0.5,2.6,1.5,3.6c4.3,4.3,8.6,8.5,12.8,12.8 c1,1,2.1,1.5,3.5,1.5c6.1-0.1,12.1,0,18.2-0.1c1.1,0,2.4-0.6,3.2-1.3c4.4-4.2,8.7-8.7,13.1-13c0.9-0.9,1.3-1.9,1.3-3.2 c0-3,0-6.1,0-9.1C58.8,29.1,58.8,25.9,58.6,22.6z M37.3,49.2h-5.4V21.5c-1,0.7-2,1.3-3.2,1.8s-2.4,0.9-3.9,1.3V20 c0.9-0.3,1.8-0.6,2.6-0.9s1.7-0.7,2.5-1.1s1.6-0.9,2.5-1.4s1.7-1.1,2.6-1.7h2.3V49.2z"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "_stop2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z M2.7,32c0,3.5-0.1,6.9,0.1,10.4 c0.1,1.1,0.6,2.4,1.3,3.2c4.8,5,9.6,9.8,14.6,14.6c0.8,0.7,2.1,1.3,3.2,1.3c6.8,0.1,13.7,0.1,20.5,0c1.1,0,2.4-0.6,3.2-1.3 c4.9-4.8,9.7-9.7,14.6-14.6c0.9-0.9,1.3-1.9,1.3-3.2c0-6.9,0-13.9-0.1-20.8c0-1-0.4-2.1-1.1-2.8c-5-5.1-10-10.1-15-15 c-0.7-0.7-1.9-1.1-2.8-1.2c-6.9-0.1-13.9-0.1-20.8,0c-1,0-2.2,0.5-2.9,1.2c-5,4.8-9.8,9.8-14.7,14.7c-1,1-1.4,2-1.3,3.4 C2.8,25.2,2.7,28.6,2.7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,22.6c-0.1-1-0.5-2.2-1.2-2.9c-4.3-4.4-8.7-8.7-13-13.1c-1-1-2.1-1.4-3.4-1.4c-6,0-12,0-18,0c-1.7-0.1-2.7,0.5-3.8,1.6 c-4.1,4.2-8.3,8.4-12.5,12.6c-1,1-1.5,2.1-1.5,3.5c0,6.1,0,12.1,0,18.1c0,1.4,0.5,2.6,1.5,3.6c4.3,4.3,8.6,8.5,12.8,12.8 c1,1,2.1,1.5,3.5,1.5c6.1-0.1,12.1,0,18.2-0.1c1.1,0,2.4-0.6,3.2-1.3c4.4-4.2,8.7-8.7,13.1-13c0.9-0.9,1.3-1.9,1.3-3.2 c0-3,0-6.1,0-9.1C58.8,29.1,58.8,25.9,58.6,22.6z M42.5,49.1H21.5v-2.6c0-1.1,0.1-2.1,0.4-3s0.7-1.8,1.2-2.6s1.1-1.6,1.8-2.3 s1.4-1.4,2.2-2.1s1.5-1.3,2.3-2s1.6-1.3,2.3-1.9c0.7-0.6,1.4-1.2,2-1.8s1.1-1.2,1.5-1.8s0.8-1.3,1-2s0.4-1.4,0.4-2.3 c0-0.9-0.1-1.7-0.4-2.3s-0.7-1.2-1.1-1.7s-1.1-0.8-1.7-1s-1.4-0.3-2.2-0.3c-1.4,0-2.8,0.3-4.2,1s-2.8,1.6-4.1,2.9V18 c0.7-0.5,1.4-1,2.1-1.3s1.4-0.7,2.2-1s1.5-0.4,2.4-0.6s1.7-0.2,2.6-0.2c1.5,0,2.9,0.2,4.1,0.6s2.3,1,3.2,1.8s1.6,1.7,2,2.9 s0.7,2.5,0.7,4c0,1.4-0.2,2.6-0.5,3.7s-0.8,2.1-1.4,3s-1.4,1.8-2.2,2.7s-1.9,1.7-2.9,2.6c-0.9,0.7-1.8,1.4-2.7,2.1 c-0.9,0.7-1.7,1.4-2.4,2s-1.3,1.3-1.7,2s-0.7,1.3-0.7,2v0.1h15.2V49.1z"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "_stop3",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z M2.7,32c0,3.5-0.1,6.9,0.1,10.4 c0.1,1.1,0.6,2.4,1.3,3.2c4.8,5,9.6,9.8,14.6,14.6c0.8,0.7,2.1,1.3,3.2,1.3c6.8,0.1,13.7,0.1,20.5,0c1.1,0,2.4-0.6,3.2-1.3 c4.9-4.8,9.7-9.7,14.6-14.6c0.9-0.9,1.3-1.9,1.3-3.2c0-6.9,0-13.9-0.1-20.8c0-1-0.4-2.1-1.1-2.8c-5-5.1-10-10.1-15-15 c-0.7-0.7-1.9-1.1-2.8-1.2c-6.9-0.1-13.9-0.1-20.8,0c-1,0-2.2,0.5-2.9,1.2c-5,4.8-9.8,9.8-14.7,14.7c-1,1-1.4,2-1.3,3.4 C2.8,25.2,2.7,28.6,2.7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,22.6c-0.1-1-0.5-2.2-1.2-2.9c-4.3-4.4-8.7-8.7-13-13.1c-1-1-2.1-1.4-3.4-1.4c-6,0-12,0-18,0c-1.7-0.1-2.7,0.5-3.8,1.6 c-4.1,4.2-8.3,8.4-12.5,12.6c-1,1-1.5,2.1-1.5,3.5c0,6.1,0,12.1,0,18.1c0,1.4,0.5,2.6,1.5,3.6c4.3,4.3,8.6,8.5,12.8,12.8 c1,1,2.1,1.5,3.5,1.5c6.1-0.1,12.1,0,18.2-0.1c1.1,0,2.4-0.6,3.2-1.3c4.4-4.2,8.7-8.7,13.1-13c0.9-0.9,1.3-1.9,1.3-3.2 c0-3,0-6.1,0-9.1C58.8,29.1,58.8,25.9,58.6,22.6z M38.8,46.6c-2.3,1.9-5.3,2.8-9,2.8c-3.3,0-6-0.6-8-1.8v-5.1 c2.2,1.7,4.7,2.6,7.4,2.6c2.2,0,4-0.5,5.4-1.5s2-2.4,2-4.1c0-3.8-2.9-5.7-8.7-5.7h-2.6v-4.4h2.5c5.2,0,7.8-1.8,7.8-5.4 c0-3.3-2-5-6-5c-2.3,0-4.4,0.8-6.4,2.4v-4.8c2.3-1.3,5-1.9,8.1-1.9c3,0,5.4,0.8,7.2,2.3s2.7,3.4,2.7,5.8c0,4.4-2.3,7.3-6.8,8.5v0.1 c2.4,0.2,4.3,1.1,5.7,2.5s2.1,3.3,2.1,5.5C42.2,42.3,41,44.7,38.8,46.6z"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "_stop4",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z M2.7,32c0,3.5-0.1,6.9,0.1,10.4 c0.1,1.1,0.6,2.4,1.3,3.2c4.8,5,9.6,9.8,14.6,14.6c0.8,0.7,2.1,1.3,3.2,1.3c6.8,0.1,13.7,0.1,20.5,0c1.1,0,2.4-0.6,3.2-1.3 c4.9-4.8,9.7-9.7,14.6-14.6c0.9-0.9,1.3-1.9,1.3-3.2c0-6.9,0-13.9-0.1-20.8c0-1-0.4-2.1-1.1-2.8c-5-5.1-10-10.1-15-15 c-0.7-0.7-1.9-1.1-2.8-1.2c-6.9-0.1-13.9-0.1-20.8,0c-1,0-2.2,0.5-2.9,1.2c-5,4.8-9.8,9.8-14.7,14.7c-1,1-1.4,2-1.3,3.4 C2.8,25.2,2.7,28.6,2.7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,37.3h9.7V23.2c-1.7,3.1-3.4,5.7-5.1,8S26.2,35.5,24.8,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,22.6c-0.1-1-0.5-2.2-1.2-2.9c-4.3-4.4-8.7-8.7-13-13.1c-1-1-2.1-1.4-3.4-1.4c-6,0-12,0-18,0 c-1.7-0.1-2.7,0.5-3.8,1.6c-4.1,4.2-8.3,8.4-12.5,12.6c-1,1-1.5,2.1-1.5,3.5c0,6.1,0,12.1,0,18.1c0,1.4,0.5,2.6,1.5,3.6 c4.3,4.3,8.6,8.5,12.8,12.8c1,1,2.1,1.5,3.5,1.5c6.1-0.1,12.1,0,18.2-0.1c1.1,0,2.4-0.6,3.2-1.3c4.4-4.2,8.7-8.7,13.1-13 c0.9-0.9,1.3-1.9,1.3-3.2c0-3,0-6.1,0-9.1C58.8,29.1,58.8,25.9,58.6,22.6z M44.8,41.8h-5v7.4h-5.3v-7.4H19.3v-4.6 c1.4-1.5,2.8-3.2,4.2-5s2.8-3.6,4.2-5.5s2.6-3.8,3.7-5.7s2.1-3.7,2.9-5.4h5.5v21.7h5V41.8z"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "_stop5",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,32c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C7.7,12.6,12.8,7.4,18.1,2.2c0.7-0.7,1.9-1.1,2.8-1.1 C28.3,1,35.7,1,43.2,1.1c1,0,2.3,0.5,3,1.3C51.4,7.5,56.7,12.7,61.8,18c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3c-5.1,5.1-10.3,10.2-15.4,15.3c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C1.1,39.2,1.1,35.6,1.1,32z M2.7,32c0,3.5-0.1,6.9,0.1,10.4 c0.1,1.1,0.6,2.4,1.3,3.2c4.8,5,9.6,9.8,14.6,14.6c0.8,0.7,2.1,1.3,3.2,1.3c6.8,0.1,13.7,0.1,20.5,0c1.1,0,2.4-0.6,3.2-1.3 c4.9-4.8,9.7-9.7,14.6-14.6c0.9-0.9,1.3-1.9,1.3-3.2c0-6.9,0-13.9-0.1-20.8c0-1-0.4-2.1-1.1-2.8c-5-5.1-10-10.1-15-15 c-0.7-0.7-1.9-1.1-2.8-1.2c-6.9-0.1-13.9-0.1-20.8,0c-1,0-2.2,0.5-2.9,1.2c-5,4.8-9.8,9.8-14.7,14.7c-1,1-1.4,2-1.3,3.4 C2.8,25.2,2.7,28.6,2.7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,22.6c-0.1-1-0.5-2.2-1.2-2.9c-4.3-4.4-8.7-8.7-13-13.1c-1-1-2.1-1.4-3.4-1.4c-6,0-12,0-18,0c-1.7-0.1-2.7,0.5-3.8,1.6 c-4.1,4.2-8.3,8.4-12.5,12.6c-1,1-1.5,2.1-1.5,3.5c0,6.1,0,12.1,0,18.1c0,1.4,0.5,2.6,1.5,3.6c4.3,4.3,8.6,8.5,12.8,12.8 c1,1,2.1,1.5,3.5,1.5c6.1-0.1,12.1,0,18.2-0.1c1.1,0,2.4-0.6,3.2-1.3c4.4-4.2,8.7-8.7,13.1-13c0.9-0.9,1.3-1.9,1.3-3.2 c0-3,0-6.1,0-9.1C58.8,29.1,58.8,25.9,58.6,22.6z M38.6,46.1c-2.2,2-5.3,3-9.2,3c-3.3,0-5.7-0.5-7.3-1.4v-5.2 c2.2,1.5,4.4,2.2,6.7,2.2c2.3,0,4.1-0.6,5.5-1.7s2.1-2.7,2.1-4.7c0-1.9-0.7-3.4-2.1-4.5s-3.4-1.6-6.1-1.6c-0.9,0-2.7,0.1-5.5,0.3 l1.2-17.7h16.5v4.6h-12l-0.6,8.4c1.1-0.1,2.1-0.1,2.9-0.1c3.6,0,6.3,0.9,8.3,2.7s2.9,4.3,2.9,7.5C41.9,41.4,40.8,44.1,38.6,46.1z"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "_map",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 63C31.5 63 55.125 40.6114 55.125 23.625C55.125 17.3593 52.6359 11.3501 48.2054 6.9196C43.7749 2.48906 37.7657 0 31.5 0C25.2343 0 19.2251 2.48906 14.7946 6.9196C10.3641 11.3501 7.875 17.3593 7.875 23.625C7.875 40.6114 31.5 63 31.5 63ZM31.5 35.4375C28.3671 35.4375 25.3626 34.193 23.1473 31.9777C20.932 29.7624 19.6875 26.7579 19.6875 23.625C19.6875 20.4921 20.932 17.4876 23.1473 15.2723C25.3626 13.057 28.3671 11.8125 31.5 11.8125C34.6329 11.8125 37.6374 13.057 39.8527 15.2723C42.068 17.4876 43.3125 20.4921 43.3125 23.625C43.3125 26.7579 42.068 29.7624 39.8527 31.9777C37.6374 34.193 34.6329 35.4375 31.5 35.4375Z"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "_map_u",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0C38.3652 0 44.4698 2.52842 48.9707 7.0293C53.4716 11.5302 56 17.6348 56 24C56 41.256 32 64 32 64C32 64 8 41.256 8 24C8 17.6348 10.5284 11.5302 15.0293 7.0293C19.5302 2.52842 25.6348 0 32 0ZM32 28C25.3726 28 20 31.5817 20 36C20 40.4183 20.0002 44 22 44H42C44 43.9997 44 38.3893 44 36C44 31.5817 38.6273 28 32 28ZM32 12C27.5817 12 24 15.5817 24 20C24 24.4183 27.5817 28 32 28C36.4183 28 40 24.4183 40 20C40 15.5817 36.4183 12 32 12Z"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "_map_o",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6 11.2C57.6 10.09 57.03 9.06 56.08 8.48C55.13 7.89999 53.96 7.83999 52.97 8.33999L41.35 14.15L23.41 8.15999C22.6 7.88999 21.73 7.95 20.97 8.33L8.17002 14.73C7.08002 15.28 6.40002 16.39 6.40002 17.6V52.8C6.40002 53.91 6.97002 54.94 7.92002 55.52C8.87002 56.1 10.04 56.16 11.03 55.66L22.64 49.85L39.97 55.63C39.54 54.99 39.12 54.32 38.71 53.64C37.61 51.81 36.52 49.71 35.71 47.46L25.59 44.09V15.64L38.39 19.91V29.84C41.49 26.26 46.09 24 51.19 24C53.45 24 55.61 24.44 57.59 25.25L57.6 11.2ZM51.2 28.8C44.57 28.8 39.2 34.08 39.2 40.59C39.2 47.48 45.61 55.63 49.06 59.52C50.22 60.82 52.19 60.82 53.35 59.52C56.8 55.63 63.21 47.48 63.21 40.59C63.21 34.08 57.84 28.8 51.21 28.8H51.2ZM47.2 40.8C47.2 38.59 48.99 36.8 51.2 36.8C53.41 36.8 55.2 38.59 55.2 40.8C55.2 43.01 53.41 44.8 51.2 44.8C48.99 44.8 47.2 43.01 47.2 40.8Z"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "_chart",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4127 0C24.7962 0 23.2458 0.682311 22.1028 1.89683C20.9597 3.11135 20.3175 4.7586 20.3175 6.47619V10.7937C20.3175 12.5112 20.9597 14.1585 22.1028 15.373C23.2458 16.5875 24.7962 17.2698 26.4127 17.2698H38.6032C40.2198 17.2698 41.7701 16.5875 42.9132 15.373C44.0563 14.1585 44.6985 12.5112 44.6985 10.7937V6.47619C44.6985 4.7586 44.0563 3.11135 42.9132 1.89683C41.7701 0.682311 40.2198 0 38.6032 0L26.4127 0ZM38.6032 4.31746C39.1421 4.31746 39.6589 4.5449 40.0399 4.94974C40.4209 5.35458 40.635 5.90366 40.635 6.47619V10.7937C40.635 11.3662 40.4209 11.9153 40.0399 12.3201C39.6589 12.7249 39.1421 12.9524 38.6032 12.9524H26.4127C25.8739 12.9524 25.3571 12.7249 24.9761 12.3201C24.5951 11.9153 24.381 11.3662 24.381 10.7937V6.47619C24.381 5.90366 24.5951 5.35458 24.9761 4.94974C25.3571 4.5449 25.8739 4.31746 26.4127 4.31746H38.6032Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.254 6.09525H12.1905C10.0351 6.09525 7.96792 6.93672 6.44382 8.43454C4.91971 9.93237 4.06348 11.9639 4.06348 14.0821V56.0131C4.06348 58.1314 4.91971 60.1629 6.44382 61.6607C7.96792 63.1585 10.0351 64 12.1905 64H52.8254C54.9808 64 57.0479 63.1585 58.572 61.6607C60.0961 60.1629 60.9524 58.1314 60.9524 56.0131V14.0821C60.9524 11.9639 60.0961 9.93237 58.572 8.43454C57.0479 6.93672 54.9808 6.09525 52.8254 6.09525H48.7619V10.0887C48.7619 11.3997 48.4991 12.698 47.9886 13.9092C47.4781 15.1205 46.7298 16.2211 45.7865 17.1481C44.8431 18.0752 43.7233 18.8106 42.4907 19.3123C41.2582 19.814 39.9372 20.0723 38.6032 20.0723H26.4127C23.7184 20.0723 21.1345 19.0204 19.2294 17.1481C17.3242 15.2758 16.254 12.7365 16.254 10.0887V6.09525ZM40.6349 32.0526C40.6349 30.9934 41.063 29.9777 41.8251 29.2288C42.5871 28.4799 43.6207 28.0591 44.6984 28.0591C45.7761 28.0591 46.8097 28.4799 47.5717 29.2288C48.3338 29.9777 48.7619 30.9934 48.7619 32.0526V52.0197C48.7619 53.0788 48.3338 54.0946 47.5717 54.8435C46.8097 55.5924 45.7761 56.0131 44.6984 56.0131C43.6207 56.0131 42.5871 55.5924 41.8251 54.8435C41.063 54.0946 40.6349 53.0788 40.6349 52.0197V32.0526ZM16.254 48.0263C16.254 46.9672 16.6821 45.9514 17.4441 45.2025C18.2062 44.4536 19.2397 44.0328 20.3174 44.0328C21.3952 44.0328 22.4287 44.4536 23.1908 45.2025C23.9528 45.9514 24.3809 46.9672 24.3809 48.0263V52.0197C24.3809 53.0788 23.9528 54.0946 23.1908 54.8435C22.4287 55.5924 21.3952 56.0131 20.3174 56.0131C19.2397 56.0131 18.2062 55.5924 17.4441 54.8435C16.6821 54.0946 16.254 53.0788 16.254 52.0197V48.0263ZM32.5079 36.046C33.5856 36.046 34.6192 36.4667 35.3812 37.2156C36.1433 37.9645 36.5714 38.9803 36.5714 40.0394V52.0197C36.5714 53.0788 36.1433 54.0946 35.3812 54.8435C34.6192 55.5924 33.5856 56.0131 32.5079 56.0131C31.4302 56.0131 30.3967 55.5924 29.6346 54.8435C28.8725 54.0946 28.4444 53.0788 28.4444 52.0197V40.0394C28.4444 38.9803 28.8725 37.9645 29.6346 37.2156C30.3967 36.4667 31.4302 36.046 32.5079 36.046Z"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "_speaker",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69398,2.03934 C8.85274,2.10632571 8.96388449,2.24923469 8.99240006,2.41528887 L8.99961,2.50000038 L8.99961,13.5000004 C8.99961,13.7014 8.87875,13.8832 8.693,13.9611 C8.53378571,14.0278714 8.35355184,14.0071408 8.21482501,13.9109991 L8.14921,13.8567 L5.22278,10.9817 L3.49963,10.9817 C2.71994059,10.9817 2.07918211,10.3867879 2.00649665,9.62617244 L1.99963,9.48172 L1.99963,6.49273 C1.99963,5.71304059 2.59452439,5.07228211 3.3551711,4.99959665 L3.49963,4.99273 L5.22402,4.99273 L8.15073,2.14185 C8.29474,2.00157 8.50875,1.96119 8.69398,2.03934 Z M11.7373527,3.05918137 L11.8239,3.11798 L11.9217,3.20255 C11.9846,3.25908 12.0714,3.34097 12.1742,3.4477 C12.3795,3.66089 12.6501,3.97503 12.9201,4.38627 C13.4605,5.20938 14.0029,6.42934 14.0029,8.00405 C14.0029,9.57884 13.4604,10.797 12.9197,11.6183 C12.6496,12.0286 12.3789,12.3418 12.1735,12.5543 L12.0322375,12.6952375 L11.8455,12.8642 L11.8125,12.8913 C11.596,13.0628 11.2808,13.0269 11.1093,12.8105 C10.9572111,12.6185 10.9687568,12.3493049 11.1244122,12.1712638 L11.2536,12.0538 C11.3002,12.0121 11.3697,11.947 11.4545,11.8593 C11.6244,11.6835 11.8541,11.4184 12.0845,11.0685 C12.5446,10.3694 13.0029,9.33953 13.0029,8.00405 C13.0029,6.66847 12.5446,5.63643 12.0841,4.93509 C11.8921,4.64260667 11.7005167,4.40900528 11.5435514,4.2370694 L11.3743556,4.06079556 L11.19,3.89138 C10.9743,3.71932 10.9382,3.40451 11.1101,3.18858 C11.2629889,2.99655333 11.5284704,2.94701753 11.7373527,3.05918137 Z M10.738123,5.05908272 L10.8377,5.12882 L10.9713519,5.2545563 L11.0254,5.31119 C11.1389,5.43362 11.2853,5.61296 11.4303,5.85143 C11.7218,6.33096 12.0039,7.04439 12.0039,7.99855 C12.0039,8.95268 11.7218,9.66687 11.4305,10.1471 C11.2857,10.3859 11.1393,10.5657 11.0259,10.6884 L10.924337,10.7926667 L10.85405,10.8576875 L10.8143,10.8914 L10.7508162,10.9202127 C10.6184284,10.9732432 10.3088308,11.0596692 10.1116,10.8129 C9.95912,10.6221444 9.96896296,10.3540358 10.1225171,10.1753077 L10.2569704,10.0460741 L10.2914,10.0098 C10.3659,9.92923 10.47,9.80248 10.5755,9.62847 C10.7851,9.28301 11.0039,8.74609 11.0039,7.99855 C11.0039,7.25106 10.7851,6.71522 10.5758,6.3709 C10.496675,6.240805 10.4183938,6.13727688 10.3528531,6.05982625 L10.2575963,5.95495148 L10.1891,5.88995 C9.97439,5.71873 9.93908,5.40472 10.1109,5.18874 C10.2637,4.99665111 10.5291716,4.94700568 10.738123,5.05908272 Z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_menu",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 0
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn",
    width: 64,
    height: 64,
    x: 64
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_empty",
    width: 64,
    height: 64,
    x: 128
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_log",
    style: {
      fill: "#00000088"
    },
    width: 64,
    height: 64,
    x: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_refr",
    style: {
      fill: "#00000088"
    },
    width: 64,
    height: 64,
    x: 256
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_repo",
    style: {
      fill: "#00000088"
    },
    width: 64,
    height: 64,
    x: 320
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_qr",
    style: {
      fill: "#00000088"
    },
    width: 64,
    height: 64,
    x: 384
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#FFAAAA"
    },
    width: 64,
    height: 64,
    x: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ok",
    style: {
      fill: "#A0F065"
    },
    width: 64,
    height: 64,
    x: 512
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_key_b",
    width: 64,
    height: 64,
    x: 576
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_key_s",
    width: 64,
    height: 64,
    x: 640
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_key_c",
    width: 64,
    height: 64,
    x: 704
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn_2",
    width: 128,
    height: 64,
    x: 768
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn1",
    width: 64,
    height: 64,
    x: 0,
    y: 64
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn2",
    width: 64,
    height: 64,
    x: 64,
    y: 64
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn3",
    width: 64,
    height: 64,
    x: 128,
    y: 64
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn4",
    width: 64,
    height: 64,
    x: 192,
    y: 64
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn5",
    width: 64,
    height: 64,
    x: 256,
    y: 64
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn6",
    width: 64,
    height: 64,
    x: 320,
    y: 64
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn7",
    width: 64,
    height: 64,
    x: 384,
    y: 64
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn8",
    width: 64,
    height: 64,
    x: 448,
    y: 64
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn9",
    width: 64,
    height: 64,
    x: 512,
    y: 64
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn10",
    width: 64,
    height: 64,
    x: 576,
    y: 64
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn11",
    width: 64,
    height: 64,
    x: 640,
    y: 64
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn12",
    width: 64,
    height: 64,
    x: 704,
    y: 64
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn13",
    width: 64,
    height: 64,
    x: 768,
    y: 64
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn81",
    width: 64,
    height: 64,
    x: 832,
    y: 64
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn14",
    width: 64,
    height: 64,
    x: 0,
    y: 128
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_gst",
    style: {
      fill: "#00000088"
    },
    width: 64,
    height: 64,
    x: 64,
    y: 128
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_comm",
    style: {
      fill: "#00000088"
    },
    width: 64,
    height: 64,
    x: 128,
    y: 128
  }), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_956",
    width: 64,
    height: 48,
    fill: "grey",
    x: 192,
    y: 138
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn18",
    width: 64,
    height: 64,
    x: 256,
    y: 128
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn19",
    width: 64,
    height: 64,
    x: 320,
    y: 128
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn20",
    width: 64,
    height: 64,
    x: 384,
    y: 128
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn21",
    width: 64,
    height: 64,
    x: 448,
    y: 128
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn22",
    width: 64,
    height: 64,
    x: 512,
    y: 128
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn23",
    width: 64,
    height: 64,
    x: 576,
    y: 128
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn24",
    width: 64,
    height: 64,
    x: 640,
    y: 128
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn25",
    width: 64,
    height: 64,
    x: 704,
    y: 128
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_btn26",
    width: 64,
    height: 64,
    x: 768,
    y: 128
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_gst2",
    width: 64,
    height: 64,
    x: 832,
    y: 128
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc1",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 0,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc2",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 64,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc3",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 128,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc4",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 192,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc5",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 256,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc6",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 320,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc7",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 384,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc8",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 448,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc9",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 512,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calc0",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 576,
    y: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calcd",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 640,
    y: 192
  }), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calcx",
    width: 64,
    height: 64,
    x: 704,
    y: 192
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_calco",
    width: 64,
    height: 64,
    x: 768,
    y: 192
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_deliv",
    width: 64,
    height: 64,
    x: 832,
    y: 192
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_503",
    style: {
      fill: "#00000088"
    },
    width: 48,
    height: 48,
    x: 8,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_pencil2",
    style: {
      fill: "#00000088"
    },
    width: 48,
    height: 48,
    x: 72,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_send",
    style: {
      fill: "#00000088"
    },
    width: 48,
    height: 48,
    x: 136,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_menu2",
    style: {
      fill: "#00000088"
    },
    width: 48,
    height: 48,
    x: 200,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_menu3",
    style: {
      fill: "#00000088"
    },
    width: 48,
    height: 48,
    x: 264,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_cal2",
    style: {
      fill: "#000000cc"
    },
    width: 48,
    height: 48,
    x: 328,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_mod",
    style: {
      fill: "#00000088"
    },
    width: 48,
    height: 48,
    x: 392,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_stl",
    style: {
      fill: "#00000088"
    },
    width: 48,
    height: 48,
    x: 456,
    y: 264
  }), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_cert",
    width: 48,
    height: 48,
    x: 520,
    y: 264
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_stop",
    style: {
      fill: "#FF0000"
    },
    width: 48,
    height: 48,
    x: 584,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_map",
    style: {
      fill: "#FFFFFF"
    },
    width: 48,
    height: 48,
    x: 648,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_map_u",
    style: {
      fill: "#FFFFFF"
    },
    width: 48,
    height: 48,
    x: 712,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_map_o",
    style: {
      fill: "#FFFFFF"
    },
    width: 48,
    height: 48,
    x: 776,
    y: 264
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_chart",
    style: {
      fill: "#FFFFFF"
    },
    width: 48,
    height: 48,
    x: 840,
    y: 264
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 352,
    r: 20,
    style: {
      fill: "#B5D7D8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 352,
    r: 20,
    style: {
      fill: "#9966CC"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 352,
    r: 20,
    style: {
      fill: "#ABD7D8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 352,
    r: 20,
    style: {
      fill: "#95bae1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 352,
    r: 20,
    style: {
      fill: "#baafe8"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_speaker",
    style: {
      fill: "#00000088"
    },
    width: 58,
    height: 58,
    x: 840,
    y: 328
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_stop1",
    style: {
      fill: "#FF0000"
    },
    width: 48,
    height: 48,
    x: 520,
    y: 328
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_stop2",
    style: {
      fill: "#FF0000"
    },
    width: 48,
    height: 48,
    x: 584,
    y: 328
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_stop3",
    style: {
      fill: "#FF0000"
    },
    width: 48,
    height: 48,
    x: 648,
    y: 328
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_stop4",
    style: {
      fill: "#FF0000"
    },
    width: 48,
    height: 48,
    x: 712,
    y: 328
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_stop5",
    style: {
      fill: "#FF0000"
    },
    width: 48,
    height: 48,
    x: 776,
    y: 328
  }), _view || (_view = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "menu",
    viewBox: "0 0 64 64"
  })), _view2 || (_view2 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn",
    viewBox: "64 0 64 64"
  })), _view3 || (_view3 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "empty",
    viewBox: "128 0 64 64"
  })), _view4 || (_view4 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "log",
    viewBox: "192 0 64 64"
  })), _view5 || (_view5 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "refr",
    viewBox: "256 0 64 64"
  })), _view6 || (_view6 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "repo",
    viewBox: "320 0 64 64"
  })), _view7 || (_view7 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "rro",
    viewBox: "384 0 64 64"
  })), _view8 || (_view8 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "key_x",
    viewBox: "448 0 64 64"
  })), _view9 || (_view9 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "key_o",
    viewBox: "512 0 64 64"
  })), _view10 || (_view10 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "key_b",
    viewBox: "576 0 64 64"
  })), _view11 || (_view11 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "key_s",
    viewBox: "640 0 64 64"
  })), _view12 || (_view12 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "key_c",
    viewBox: "704 0 64 64"
  })), _view13 || (_view13 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn_2",
    viewBox: "768 0 128 64"
  })), _view14 || (_view14 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn1",
    viewBox: "0 64 64 64"
  })), _view15 || (_view15 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn2",
    viewBox: "64 64 64 64"
  })), _view16 || (_view16 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn3",
    viewBox: "320 256 64 64"
  })), _view17 || (_view17 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn4",
    viewBox: "192 64 64 64"
  })), _view18 || (_view18 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn5",
    viewBox: "256 64 64 64"
  })), _view19 || (_view19 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn6",
    viewBox: "320 64 64 64"
  })), _view20 || (_view20 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn7",
    viewBox: "384 64 64 64"
  })), _view21 || (_view21 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn8",
    viewBox: "448 64 64 64"
  })), _view22 || (_view22 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn9",
    viewBox: "512 64 64 64"
  })), _view23 || (_view23 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn10",
    viewBox: "576 64 64 64"
  })), _view24 || (_view24 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn11",
    viewBox: "640 64 64 64"
  })), _view25 || (_view25 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn12",
    viewBox: "704 64 64 64"
  })), _view26 || (_view26 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn13",
    viewBox: "768 64 64 64"
  })), _view27 || (_view27 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn81",
    viewBox: "832 64 64 64"
  })), _view28 || (_view28 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn14",
    viewBox: "0 128 64 64"
  })), _view29 || (_view29 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn15",
    viewBox: "64 128 64 64"
  })), _view30 || (_view30 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn16",
    viewBox: "128 128 64 64"
  })), _view31 || (_view31 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b956",
    viewBox: "192 128 64 64"
  })), _view32 || (_view32 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn18h",
    viewBox: "256 128 64 64"
  })), _view33 || (_view33 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn19h",
    viewBox: "320 128 64 64"
  })), _view34 || (_view34 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn20h",
    viewBox: "384 128 64 64"
  })), _view35 || (_view35 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn21h",
    viewBox: "448 128 64 64"
  })), _view36 || (_view36 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn18v",
    viewBox: "512 128 64 64"
  })), _view37 || (_view37 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn19v",
    viewBox: "576 128 64 64"
  })), _view38 || (_view38 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn20v",
    viewBox: "640 128 64 64"
  })), _view39 || (_view39 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn21v",
    viewBox: "704 128 64 64"
  })), _view40 || (_view40 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn22",
    viewBox: "768 128 64 64"
  })), _view41 || (_view41 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn23",
    viewBox: "832 128 64 64"
  })), _view42 || (_view42 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc1",
    viewBox: "0 192 64 64"
  })), _view43 || (_view43 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc2",
    viewBox: "64 192 64 64"
  })), _view44 || (_view44 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc3",
    viewBox: "128 192 64 64"
  })), _view45 || (_view45 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc4",
    viewBox: "192 192 64 64"
  })), _view46 || (_view46 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc5",
    viewBox: "256 192 64 64"
  })), _view47 || (_view47 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc6",
    viewBox: "320 192 64 64"
  })), _view48 || (_view48 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc7",
    viewBox: "384 192 64 64"
  })), _view49 || (_view49 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc8",
    viewBox: "448 192 64 64"
  })), _view50 || (_view50 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc9",
    viewBox: "512 192 64 64"
  })), _view51 || (_view51 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calc0",
    viewBox: "576 192 64 64"
  })), _view52 || (_view52 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calcd",
    viewBox: "640 192 64 64"
  })), _view53 || (_view53 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calcx",
    viewBox: "704 192 64 64"
  })), _view54 || (_view54 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "calco",
    viewBox: "768 192 64 64"
  })), _view55 || (_view55 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn24",
    viewBox: "832 192 64 64"
  })), _view56 || (_view56 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b503",
    viewBox: "0 256 64 64"
  })), _view57 || (_view57 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b402",
    viewBox: "64 256 64 64"
  })), _view58 || (_view58 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b401",
    viewBox: "128 256 64 64"
  })), _view59 || (_view59 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "v_menu",
    viewBox: "256 256 64 64"
  })), _view60 || (_view60 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "h_menu",
    viewBox: "192 256 64 64"
  })), _view61 || (_view61 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn14_",
    viewBox: "384 256 64 64"
  })), _view62 || (_view62 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "thm",
    viewBox: "448 256 64 64"
  })), _view63 || (_view63 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "cert",
    viewBox: "512 256 64 64"
  })), _view64 || (_view64 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "stop",
    viewBox: "576 256 64 64"
  })), _view65 || (_view65 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "map",
    viewBox: "640 256 64 64"
  })), _view66 || (_view66 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "map_u",
    viewBox: "704 256 64 64"
  })), _view67 || (_view67 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "map_o",
    viewBox: "768 256 64 64"
  })), _view68 || (_view68 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "chart",
    viewBox: "832 256 64 64"
  })), _view69 || (_view69 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "thm1",
    viewBox: "0 320 64 64"
  })), _view70 || (_view70 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "thm2",
    viewBox: "64 320 64 64"
  })), _view71 || (_view71 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "thm_0",
    viewBox: "128 320 64 64"
  })), _view72 || (_view72 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "thm_2",
    viewBox: "192 320 64 64"
  })), _view73 || (_view73 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "thm_3",
    viewBox: "256 320 64 64"
  })), _view74 || (_view74 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "stop1",
    viewBox: "520 320 64 64"
  })), _view75 || (_view75 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "stop2",
    viewBox: "584 320 64 64"
  })), _view76 || (_view76 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "stop3",
    viewBox: "648 320 64 64"
  })), _view77 || (_view77 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "stop4",
    viewBox: "712 320 64 64"
  })), _view78 || (_view78 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "stop5",
    viewBox: "776 320 64 64"
  })), _view79 || (_view79 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "speaker",
    viewBox: "840 320 64 64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.84c8b8d04ed2f148b89979d3288aadb4.svg";
export { ForwardRef as ReactComponent };